/* Arteriel concierge — drawer + page client (spec 2026-08-30 §6/§7).
 * Security invariant: untrusted data is rendered ONLY with createElement /
 * textContent. innerHTML is forbidden in this file. */
(function () {
  "use strict";
  // Market subfolder prefix (assets/locale-links.js); falls back to the bare path.
  var localePath = function (p) { return window.arterielLocalePath ? window.arterielLocalePath(p) : p; };
  // Single-mount guard: the drawer snippet AND the page section both emit this
  // script tag; a second evaluation double-binds every handler (chips appended
  // twice on the walkthrough, 2026-08-31 — same lesson as frame-builder #247).
  if (window.ArterielConcierge) return;

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  // Card actions draw quiet LINE ICONS (PDF card note 2026-09-01: save /
  // add to cart / "More like this" at 44px targets; p3 shows the outline
  // heart) — one stroked path set in currentColor; pressed states fill in
  // CSS. Replaces the emoji/text glyphs carried over from earlier waves.
  var ICONS = {
    heart: '<path d="M12 20s-7-4.6-9.3-8.8C1 8 2.6 4.9 5.7 4.6c1.9-.2 3.6.8 4.6 2.3.4.6 1 .6 1.4 0 1-1.5 2.7-2.5 4.6-2.3 3.1.3 4.7 3.4 3 6.6C19 15.4 12 20 12 20z"/>',
    bag: '<path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    board: '<rect x="5" y="5" width="14" height="14"/>',
    spark: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z"/>'
  };
  function svgIcon(name) {
    var s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", "0 0 24 24");
    s.setAttribute("fill", "none");
    s.setAttribute("stroke", "currentColor");
    s.setAttribute("stroke-width", "1.5");
    s.setAttribute("stroke-linecap", "round");
    s.setAttribute("stroke-linejoin", "round");
    s.setAttribute("aria-hidden", "true");
    s.innerHTML = ICONS[name] || "";
    return s;
  }

  function api(root, path, opts) {
    var proxy = root.getAttribute("data-proxy") || "/apps/arteriel-ai";
    return fetch(proxy + path, opts).then(function (r) {
      // A proxy/upstream failure returns Shopify's HTML error page; never let
      // a JSON parse rejection silently kill the caller's chain.
      return r.json().catch(function () { return {}; })
        .then(function (body) { return { status: r.status, body: body }; });
    });
  }

  // Shop facet vocabulary for reply markup (user report 2026-09-01):
  // fetched ONCE per page from the public facets endpoint; replies rendered
  // before it arrives re-render when it lands (progressive enhancement).
  var FACET_VOCAB = null;
  var vocabPromise = null;
  function loadFacetVocab(rootEl) {
    if (!vocabPromise) vocabPromise = api(rootEl, "/search/facets")
      .then(function (r) { FACET_VOCAB = (r.body && r.body.facets) || null; return FACET_VOCAB; })
      .catch(function () { return null; });
    return vocabPromise;
  }

  function postTurn(root, message, conversationId, prefs, page) {
    var payload = { message: message, market: root.getAttribute("data-market") || "" };
    if (conversationId) payload.conversation_id = conversationId;
    if (prefs) payload.prefs = prefs;  // structured brief (server: _valid_prefs -> system-prompt suffix)
    if (page) payload.page = page;     // G2 page context (server: _valid_page -> "currently viewing" suffix)
    return api(root, "/concierge/turn", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
  }

  function pollTurn(root, turnId, anonKey, onProgress) {
    var attempts = 0;
    return new Promise(function (resolve) {
      (function tick() {
        attempts += 1;
        var q = anonKey ? "?anon=" + encodeURIComponent(anonKey) : "";
        api(root, "/concierge/turn/" + encodeURIComponent(turnId) + q).then(function (r) {
          if (r.status !== 200) return resolve({ status: "failed", message: "unavailable" });
          if (r.body.status === "running") {
            onProgress(r.body.progress_line || "");
            if (attempts >= 120) return resolve({ status: "failed", message: "timeout" });
            return setTimeout(tick, 1000);
          }
          resolve(r.body);
        }).catch(function () { resolve({ status: "failed", message: "network" }); });
      })();
    });
  }

  // X19 (UI review 2026-09-11): the card is built from a product payload that
  // has ALREADY resolved — callers go through hydrateCards, which drops the
  // handles that 404. `buildCard` never fetches.
  function buildCard(pick, product, blurred, rank, ctx) {
    var card = el("article", "cnc-card" + (blurred ? " cnc-card--blur" : ""));
    if (pick.product_id != null) card.setAttribute("data-product-id", String(pick.product_id));
    if (pick.handle) card.setAttribute("data-handle", pick.handle);
    var frame = el("div", "cnc-card__frame");
    if (rank && !blurred) frame.appendChild(el("span", "cnc-card__rank", (rank < 10 ? "0" : "") + rank));
    var img = document.createElement("img");
    img.loading = "lazy"; img.alt = "";
    frame.appendChild(img); card.appendChild(frame);
    if (!blurred) {
      // Whole-card click-through (user report 2026-08-31): a stretched link
      // covers the card (z-index under the CTA cluster), so the PDP opens from
      // anywhere — not just the title, which may be missing while hydrating.
      if (pick.handle) {
        var stretch = el("a", "cnc-card__link");
        stretch.href = "/products/" + encodeURIComponent(pick.handle);
        stretch.setAttribute("aria-label", "View artwork");
        card.appendChild(stretch);
      }
      var a = el("a"); a.href = "/products/" + encodeURIComponent(pick.handle);
      var title = el("h3", "cnc-card__title"); var artist = el("p", "cnc-card__artist");
      // Search-grid parity (user direction 2026-09-01): artist above title,
      // the same order as the /search and collection work cards.
      card.appendChild(artist); a.appendChild(title); card.appendChild(a);
      card.appendChild(el("p", "cnc-card__price"));
      // Gate round-1 finding (2026-09-01): the model bolds inside
      // present_picks.why too — strip the markers, the why is already a
      // highlight rendered as plain text.
      card.appendChild(el("p", "cnc-card__why", parseModelMarkup(pick.why || "").text));
      if (pick.handle) {
        var viewA = el("a", "cnc-card__view", "View piece \u2192");
        viewA.href = "/products/" + encodeURIComponent(pick.handle);
        card.appendChild(viewA);
      }
      if (ctx) {
        // PDF treatment (live-walkthrough fix 2026-09-01): individual PAPER
        // chips with ink line icons — the old color-scheme-2 remap painted
        // the cluster as one solid ink bar on the storefront scheme.
        var acts = el("span", "cnc-card__actions");
        if (ctx.customer && window.ArterielFavorites && pick.product_id != null) {
          var favBtn = el("button", "cnc-card__action");
          favBtn.appendChild(svgIcon("heart"));
          favBtn.type = "button"; favBtn.setAttribute("aria-label", "Save to favorites");
          var savedNow = false;
          try {
            var cachedFav = window.ArterielFavorites.cached();
            savedNow = !!(cachedFav && cachedFav.saved && cachedFav.saved.some(function (x) { return Number(x.id) === Number(pick.product_id); }));
          } catch (e) {}
          favBtn.setAttribute("aria-pressed", savedNow ? "true" : "false");
          favBtn.addEventListener("click", function () {
            var on = favBtn.getAttribute("aria-pressed") === "true";
            favBtn.setAttribute("aria-pressed", on ? "false" : "true");
            (on ? window.ArterielFavorites.unsave(pick.product_id)
                : window.ArterielFavorites.save(pick.product_id, pick.handle))
              .catch(function () { favBtn.setAttribute("aria-pressed", on ? "true" : "false"); });
          });
          acts.appendChild(favBtn);
        } else if (!ctx.customer && ctx.loginUrl) {
          var loginA = el("a", "cnc-card__action");
          loginA.appendChild(svgIcon("heart"));
          loginA.href = signinHref(ctx.loginUrl, ctx.returnUrl);
          loginA.setAttribute("aria-label", "Sign in to save favorites");
          acts.appendChild(loginA);
        }
        if (ctx.trade && pick.handle) {
          var atp = el("a", "cnc-card__action");
          atp.appendChild(svgIcon("plus"));
          atp.href = "/products/" + encodeURIComponent(pick.handle) + "#add-to-project";
          atp.setAttribute("aria-label", "Add to project"); atp.title = "Add to project";
          acts.appendChild(atp);
        }
        if ((ctx.trade || ctx.canSelect) && pick.product_id != null) {
          // Board select (Phase B Task 12): a dedicated action button — the
          // stretched PDP link owns whole-card clicks (user report 2026-08-31),
          // so selection never hijacks navigation. Toggling is delegated to
          // initTradeRail's root listener.
          var selBtn = el("button", "cnc-card__action cnc-card__action--select");
          selBtn.appendChild(svgIcon("board"));
          selBtn.type = "button"; selBtn.setAttribute("data-cnc-select", "");
          selBtn.setAttribute("aria-pressed", "false");
          selBtn.setAttribute("aria-label", "Select for board"); selBtn.title = "Select for board";
          acts.appendChild(selBtn);
        }
        // G3a: quick-add couldn't pick a size (blind first-variant cart POST).
        // The cart action is now a PDP deep link (project-card pattern) — the fetch
        // below upgrades it to ?variant=<captured-size rung> when a scale is
        // known, and the PDP's builder handles framing from its own defaults.
        if (pick.handle) {
          var goBtn = el("a", "cnc-card__action cnc-card__action--cart");
          goBtn.appendChild(svgIcon("bag"));
          goBtn.href = pdpConfigUrl(pick.handle, null);
          goBtn.setAttribute("aria-label", "Choose size & add on the artwork page");
          goBtn.title = "Choose size & add";
          acts.appendChild(goBtn);
        }
        // PDF card note: "More like this" rides the cluster and sends a real
        // refinement turn (moreLikeSeed — same seed the follow-up chips use).
        if (ctx.moreLike && pick.handle) {
          var mlBtn = el("button", "cnc-card__action cnc-card__action--more");
          mlBtn.type = "button";
          mlBtn.setAttribute("aria-label", "More like this");
          mlBtn.title = "More like this";
          mlBtn.appendChild(svgIcon("spark"));
          mlBtn.addEventListener("click", function () {
            ctx.moreLike(card.dataset.title || pick.handle, card.dataset.artist || "", rank || 1);
          });
          acts.appendChild(mlBtn);
        }
        if (acts.firstChild) frame.appendChild(acts);
      }
    }
    applyProduct(card, img, pick, product, blurred, ctx);
    return card;
  }

  // The old hydrateCard .then body, unchanged — it now runs against a product
  // that is already in hand, before the card reaches the DOM.
  function applyProduct(card, img, pick, p, blurred, ctx) {
    if (p.featured_image) img.src = p.featured_image + "?width=480";
    card.dataset.title = p.title || "";
    card.dataset.artist = p.vendor || "";
    if (!blurred && p.price != null) {
      var priceEl = card.querySelector(".cnc-card__price");
      if (priceEl) priceEl.textContent = formatCents(p.price,
        (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD");
    }
    // Cheapest available, not first-available (live-walkthrough fix
    // 2026-09-01): the card shows p.price (the product minimum) until a
    // scale is captured — the default variant must be the one that price
    // describes, or "Add set to cart" carts a dearer framed variant than
    // the card displays.
    var av = (p.variants || []).filter(function (v) { return v.available; })
      .sort(function (a, b) { return a.price - b.price; })[0];
    var chosen = ladderVariant(p, ctx && ctx.scale ? ctx.scale() : null);
    var initial = chosen || av;
    card.dataset.variantId = (initial && initial.id) || "";
    // Framed-only products default to a framed variant — flag it here
    // too, since only the `chosen` path below runs applyCardVariant.
    if (variantFramed(p, initial)) card.dataset.framed = "true";
    if (chosen && !blurred && pick.handle) {
      // Carry the size-matched variant on every card link — the PDP opens
      // on the captured size's rung of this artwork's own ladder. The
      // shown price follows the variant too (G3b: never the first
      // variant's price when a size was asked for).
      applyCardVariant(card, p, chosen, pick.handle);
    }
    if (!blurred) {
      card.querySelector(".cnc-card__title").textContent = p.title || "";
      card.querySelector(".cnc-card__artist").textContent = (p.vendor || "").toUpperCase();
    }
    // G3b: one-tap size/substrate row — page-grid chrome (the drawer and
    // thread mini-rows hide it in CSS, cards stay minimal there).
    if (!blurred && ctx) renderSizeRow(card, p, pick.handle);
  }

  /* Product requests: bounded, and coalesced per handle (residuals 2 and 3).
   *
   * R3 — this used to be a bare fetch ending in `.catch(-> null)`, so a hung
   * request never rejected AND never resolved: the Promise.all inside
   * hydrateCards never settled and the canvas kept its cnc-grid--busy dimming
   * indefinitely instead of failing visibly. A deadline turns that into the
   * same `null` a 404 already produces, which hydratedPicks handles by
   * rendering no card at all.
   *
   * R2 — a single page turn calls hydrateCards over overlapping entries at two
   * sites (renderPicks' collapsed head and renderMiniRow's first
   * INLINE_STRIP_COUNT), synchronously in the same callback, so the top picks
   * were fetched twice per turn in parallel. inFlight joins the second caller
   * to the first caller's request.
   *
   * The two compose in ONE order: the deadline INSIDE, the memo OUTSIDE. A
   * memo wrapped around an unbounded request would pin a promise that never
   * settles and therefore never evicts, killing that handle for the life of
   * the page. And because inFlight evicts on settle it is a coalescer, not a
   * cache — a price or availability change mid-session is still picked up by
   * the next turn. */

  // resolveWithin / inFlight mirrored in assets/concierge-helpers.mjs; keep in sync.
  var PRODUCT_TIMEOUT_MS = 8000;

  function resolveWithin(start, ms, fallback, env) {
    var setT = (env && env.setTimeout) || setTimeout;
    var clearT = (env && env.clearTimeout) || clearTimeout;
    return new Promise(function (resolve) {
      var settled = false;
      var timer = null;
      var onAbort = null;
      function finish(v) {
        if (settled) return;
        settled = true;
        if (timer != null) { clearT(timer); timer = null; }
        resolve(v);
      }
      timer = setT(function () {
        timer = null;
        if (onAbort) { try { onAbort(); } catch (e) { /* abort is best-effort */ } }
        finish(fallback);
      }, ms);
      var running;
      try {
        running = start(function (fn) { onAbort = fn; });
      } catch (e) {
        finish(fallback);
        return;
      }
      Promise.resolve(running).then(finish, function () { finish(fallback); });
    });
  }

  function inFlight(store, key, start) {
    var k = "h:" + key;
    if (store[k]) return store[k];
    var running = start().then(
      function (v) { delete store[k]; return v; },
      function () { delete store[k]; return null; }
    );
    store[k] = running;
    return running;
  }

  function fetchProductJson(handle) {
    return resolveWithin(function (onAbort) {
      var ctrl = typeof AbortController === "function" ? new AbortController() : null;
      var opts = { credentials: "same-origin" };
      if (ctrl) {
        opts.signal = ctrl.signal;
        onAbort(function () { ctrl.abort(); });
      }
      return fetch("/products/" + encodeURIComponent(handle) + ".js", opts)
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    }, PRODUCT_TIMEOUT_MS, null);
  }

  var productRequests = {};

  function productJson(handle) {
    if (!handle) return Promise.resolve(null);
    return inFlight(productRequests, handle, function () { return fetchProductJson(handle); });
  }

  function entriesFor(picks, blurred) {
    return (picks || []).map(function (p) { return { pick: p, blurred: !!blurred }; });
  }

  // `rankFrom` (final review, CRITICAL 1, 2026-09-14): the page canvas
  // hydrates in two batches since the deferred collapse (spec §5.4) — the
  // collapsed head now, the remainder on expand — and the rank is a VISIBLE
  // badge (.cnc-card__rank), so the second batch continues the first's
  // numbering instead of restarting at 01 mid-canvas.
  // hydratedPicks mirrored in assets/concierge-helpers.mjs; keep in sync.
  function hydratedPicks(entries, products, rankFrom) {
    var out = [];
    var rank = Number(rankFrom) || 0;
    (entries || []).forEach(function (entry, i) {
      var product = products ? products[i] : null;
      if (!product) return;             // 404 / network failure: never rendered
      if (!entry.blurred) rank += 1;
      out.push({ entry: entry, product: product, rank: entry.blurred ? 0 : rank });
    });
    return out;
  }

  // Fetch every entry's product FIRST, then build cards from what resolved
  // (X19). Resolves to cards in entry order; a handle that 404s produces no
  // card at all instead of a permanent empty grey tile. buildCard is wrapped
  // per-entry (not just the fetch) so a malformed payload that throws inside
  // buildCard/applyProduct drops only that one card — the old inline
  // hydrateCard had its own per-card .catch; a bare Promise.all here would
  // let one bad card reject the whole batch and blank the entire surface.
  // `rankFrom` is the number of cards already RENDERED above this batch (0
  // for a first batch) — the rendered count, not the requested one, so the
  // badges stay contiguous across a 404 the way they do inside one batch.
  function hydrateCards(entries, ctx, rankFrom) {
    var list = entries || [];
    return Promise.all(list.map(function (e) { return productJson(e.pick && e.pick.handle); }))
      .then(function (products) {
        products.forEach(function (p, i) {
          if (!p) {
            try { console.warn("concierge: pick handle failed to hydrate", list[i].pick && list[i].pick.handle); }
            catch (e) {}
          }
        });
        var cards = [];
        hydratedPicks(list, products, rankFrom).forEach(function (k) {
          try {
            cards.push(buildCard(k.entry.pick, k.product, k.entry.blurred, k.rank, ctx));
          } catch (e) {
            // Distinct wording from the fetch-failure warn above (:284) —
            // this one means the product JSON DID resolve but buildCard/
            // applyProduct threw on it, a different failure to spot on the
            // dev-store console than a 404/network miss.
            try { console.warn("concierge: pick card failed to render", k.entry.pick && k.entry.pick.handle, e); }
            catch (e2) {}
          }
        });
        return cards;
      })
      .catch(function (e) {
        try { console.warn("concierge: hydrateCards failed", e); } catch (e2) {}
        return [];
      });
  }

  // hydrateCards' own .catch above only guards its Promise.all/buildCard
  // work — it resolves BEFORE the caller's .then(function (cards) {...})
  // runs, so a throw inside a call site's own callback (renderFollowups,
  // seeOnWallLink, gridCapModel, ...) is a SEPARATE promise chain and would
  // otherwise become a silent unhandled rejection that abandons the rest of
  // that callback (the hero never hides, etc.). Every hydrateCards(...).then
  // call site ends in .catch(warnRenderFailure) for exactly this reason.
  function warnRenderFailure(e) {
    try { console.error("concierge: pick surface render failed", e); } catch (e2) {}
  }

  /* Scroll a rehydrated thread to its bottom (residual 1, 2026-09-14).
   * Assigning the thread's own scrollHeight to its scrollTop measures once: it
   * cannot land on a bottom that is still moving, and it silently no-ops on a
   * thread that has no layout box at the moment it runs. loadConversation is
   * one of the places that can hit the second case — the drawer's init path
   * calls it while `root.hidden` is still true (see the storedConversation
   * branch), so the whole rehydrate, hydrate and scroll happen inside a
   * display:none subtree where scrollHeight and clientHeight are both 0.
   * Whether that is what produced the live scrollTop-0 trace was NOT
   * established, so this is written to be correct either way: measure again
   * across a bounded run of frames, assert whenever there is something to
   * assert, and stop — no unbounded loop, no timer that outlives the drawer.
   * The decision lives in the pure helpers below (mirrored in
   * assets/concierge-helpers.mjs, covered by tests/concierge-thread-scroll.test.mjs);
   * this function is only the frame pump around them.
   * Safe to call more than once — each call is its own bounded run, which is
   * why the drawer kicks it from open() as well as after the turns land. */

  // THREAD_SCROLL_FRAMES / THREAD_SCROLL_STABLE / threadScrollTarget /
  // threadScrollStep mirrored in assets/concierge-helpers.mjs; keep in sync.
  var THREAD_SCROLL_FRAMES = 24;
  var THREAD_SCROLL_STABLE = 3;

  function threadScrollTarget(metrics) {
    if (!metrics) return null;
    var max = (metrics.scrollHeight || 0) - (metrics.clientHeight || 0);
    return max > 0 ? max : null;
  }

  function threadScrollStep(state, metrics) {
    var budget = state && typeof state.budget === "number" ? state.budget : THREAD_SCROLL_FRAMES;
    var height = (metrics && metrics.scrollHeight) || 0;
    var stable = state && state.height === height ? (state.stable || 0) + 1 : 0;
    var left = budget - 1;
    return {
      target: threadScrollTarget(metrics),
      done: left <= 0 || stable >= THREAD_SCROLL_STABLE,
      state: { budget: left, stable: stable, height: height }
    };
  }

  function scrollThreadToBottom(thread) {
    if (!thread) return;
    var nextFrame = (window.requestAnimationFrame && window.requestAnimationFrame.bind(window))
      || function (fn) { return setTimeout(fn, 16); };
    var state = { budget: THREAD_SCROLL_FRAMES, stable: 0, height: null };
    function frame() {
      // The drawer was torn down (history wiped the thread, Start fresh
      // replaced it) — stop rather than fight whatever replaced it.
      if (thread.isConnected === false) return;
      var step = threadScrollStep(state, { scrollHeight: thread.scrollHeight, clientHeight: thread.clientHeight });
      state = step.state;
      if (step.target != null) thread.scrollTop = step.target;
      if (!step.done) nextFrame(frame);
    }
    frame();   // assert once now, then re-assert until the height settles
  }

  // Panel v2: the brief-token band mirrors every capture answer as a
  // removable chip ("Your brief"). Only the drawer carries the band mount —
  // the page surface has none and this no-ops there.
  function renderTokens(root, model, onRemove) {
    var band = root.querySelector("[data-cnc-tokens]");
    if (!band) return;
    var list = band.querySelector("[data-cnc-tokens-list]") || band;
    while (list.firstChild) list.removeChild(list.firstChild);
    var values = [];
    if (model) model.steps.forEach(function (step) {
      (model.picked[step.key] || []).forEach(function (v) { values.push({ key: step.key, value: v }); });
    });
    band.hidden = values.length === 0;
    values.forEach(function (t) {
      var chip = el("button", "cnc-token", t.value + " ");
      chip.type = "button";
      chip.setAttribute("aria-label", "Remove " + t.value);
      chip.appendChild(el("span", "cnc-token__x", "\u00d7"));
      if (onRemove) chip.addEventListener("click", function () { onRemove(t.key, t.value); });
      else chip.disabled = true;
      list.appendChild(chip);
    });
  }

  // historyGroups mirrored in assets/concierge-helpers.mjs; keep in sync.
  function historyGroups(conversations, now) {
    var today = [], earlier = [];
    (conversations || []).forEach(function (c) {
      var t = Date.parse(c.updated_at || "") || 0;
      (now - t < 24 * 3600 * 1000 ? today : earlier).push(c);
    });
    var groups = [];
    if (today.length) groups.push({ title: "Today", items: today });
    if (earlier.length) groups.push({ title: "Earlier", items: earlier });
    return groups;
  }

  // The theme's routes.account_login_url is NOT guaranteed to be a bare path.
  // On this store it resolves to
  //   /customer_authentication/redirect?locale=en&region_country=US
  // which ALREADY carries a query string, so appending "?return_url=" produced
  // a SECOND "?" and the return target was swallowed into region_country's
  // value — the shopper signed in and landed anywhere but where they were
  // (found live on prod 2026-09-16). Pick the separator from the URL.
  // Mirrored in assets/ai-search.js; keep in sync.
  function signinHref(loginUrl, returnUrl) {
    var base = loginUrl || "/account/login";
    return base + (base.indexOf("?") >= 0 ? "&" : "?") +
      "return_url=" + encodeURIComponent(returnUrl || "/");
  }

  // X1 (UI review 2026-09-11): the anon funnel was a dead end in both
  // directions. An anonymous shopper gets ONE turn by design
  // (`state.asked = !signedIn`), after which both compose handlers `return`
  // silently — type, press Ask, nothing happens. And the only signpost was a
  // bare <span> with no link, so there was nothing to click either. The
  // notice now always carries a real sign-in link that RETURNS to the
  // concierge, and says something different once the turn is spent:
  // "Sign in to start" reads as though the turn never happened.
  //
  // Both surfaces (bar and page) already re-render the meter immediately
  // after setting state.asked, so threading `spent` through here fixes the
  // drawer and the page in one place.
  function renderMeter(node, quota, signedIn, root, spent) {
    node.hidden = false;
    while (node.firstChild) node.removeChild(node.firstChild);
    if (!signedIn) {
      var loginUrl = (root && root.getAttribute("data-login-url")) || "/account/login";
      // Come back to where they were, not the account page. data-page-url is
      // the theme's own concierge route, so a localised storefront
      // (/en-au/...) returns to its own path rather than the hardcoded root.
      var returnUrl = (root && root.getAttribute("data-page-url")) || "/pages/concierge";
      node.appendChild(el("span", null, spent
        ? "That was your free conversation. "
        : "Sign in to start — your conversations keep. "));
      var signin = el("a", "cnc-meter__signin", spent ? "Sign in to continue" : "Sign in");
      signin.href = signinHref(loginUrl, returnUrl);
      node.appendChild(signin);
      return;
    }
    if (!quota) return;
    node.appendChild(el("span", null, quota.used + " of " + quota.limit + " conversations today"));
    var bar = el("div", "cnc-meter__bar"); var fill = el("div", "cnc-meter__fill");
    fill.style.width = Math.min(100, (quota.used / Math.max(1, quota.limit)) * 100) + "%";
    if (quota.used >= quota.limit) fill.classList.add("cnc-meter__fill--critical");
    bar.appendChild(fill); node.appendChild(bar);
  }

  // carriedSeed mirrored in assets/concierge-helpers.mjs; keep in sync.
  function carriedSeed(search) {
    var seed = "";
    try { seed = new URLSearchParams(search || "").get("seed") || ""; } catch (e) { seed = ""; }
    return seed.trim().slice(0, 300);
  }

  // capturedScale / ladderVariant / pdpConfigUrl mirrored in
  // assets/concierge-helpers.mjs; keep in sync. (G3a: scale word -> a POSITION
  // on the artwork's own tenant-derived size ladder — no inch thresholds here.)
  var SCALE_WORDS = ["small", "medium", "large", "oversize"];
  function sizeArea(token) {
    var m = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/.exec(String(token || "").toLowerCase());
    return m ? Number(m[1]) * Number(m[2]) : null;
  }
  function capturedScale(capture, prefs, mode) {
    var picked = capture && capture.picked && capture.picked.scale;
    var fromCapture = (Array.isArray(picked) ? picked : []).filter(function (w) { return SCALE_WORDS.indexOf(w) >= 0; })[0];
    if (fromCapture) return fromCapture;
    var saved = prefs && prefs[mode] && prefs[mode].scale;
    var list = Array.isArray(saved) ? saved : [saved];
    return list.filter(function (w) { return SCALE_WORDS.indexOf(w) >= 0; })[0] || null;
  }
  function ladderVariant(product, scaleWord) {
    var pos = SCALE_WORDS.indexOf(scaleWord);
    if (!product || pos < 0) return null;
    var names = (product.options || []).map(function (o) { return (o && o.name) || o; });
    var sizeIdx = Math.max(0, names.indexOf("Size"));
    function sizeOf(v) { return v["option" + (sizeIdx + 1)]; }
    var avail = (product.variants || []).filter(function (v) { return v.available && sizeArea(sizeOf(v)) != null; });
    var ladder = [];
    avail.forEach(function (v) { var t = sizeOf(v); if (ladder.indexOf(t) < 0) ladder.push(t); });
    ladder.sort(function (a, b) { return sizeArea(a) - sizeArea(b); });
    if (!ladder.length) return null;
    var rung = Math.round((pos * (ladder.length - 1)) / 3);
    var token = ladder[rung];
    return avail.filter(function (v) { return sizeOf(v) === token; })[0] || null;
  }
  // sizeRowVariant mirrored in assets/concierge-helpers.mjs; keep in sync.
  function sizeRowVariant(product, token, substrate, frame) {
    if (!product) return null;
    var names = (product.options || []).map(function (o) { return (o && o.name) || o; });
    var sizeIdx = Math.max(0, names.indexOf("Size"));
    var subIdx = names.indexOf("Substrate");
    var frameIdx = names.indexOf("Frame");
    function sizeOf(v) { return v["option" + (sizeIdx + 1)]; }
    function subOf(v) { return subIdx >= 0 ? v["option" + (subIdx + 1)] : null; }
    function frameOf(v) { return frameIdx >= 0 ? v["option" + (frameIdx + 1)] : null; }
    function unframed(v) { return frameIdx < 0 || /no frame/i.test(String(v["option" + (frameIdx + 1)] || "")); }
    var forSize = (product.variants || []).filter(function (v) { return v.available && sizeOf(v) === token; });
    if (!forSize.length) return null;
    function pick(list) { return list.slice().sort(function (a, b) { return (unframed(b) - unframed(a)) || (a.price - b.price); })[0]; }
    var bySub = forSize.filter(function (v) { return subIdx < 0 || subOf(v) === substrate; });
    var exact = (frame == null || frameIdx < 0) ? [] : bySub.filter(function (v) { return frameOf(v) === frame; });
    return pick(exact.length ? exact : (bySub.length ? bySub : forSize)) || null;
  }
  // sizeRowModel mirrored in assets/concierge-helpers.mjs; keep in sync.
  function sizeRowModel(product, currentVariantId) {
    var empty = { sizes: [], substrates: [], substrate: null, frames: [], frame: null };
    if (!product) return empty;
    var names = (product.options || []).map(function (o) { return (o && o.name) || o; });
    var sizeIdx = Math.max(0, names.indexOf("Size"));
    var subIdx = names.indexOf("Substrate");
    var frameIdx = names.indexOf("Frame");
    function sizeOf(v) { return v["option" + (sizeIdx + 1)]; }
    function subOf(v) { return subIdx >= 0 ? v["option" + (subIdx + 1)] : null; }
    function frameOf(v) { return frameIdx >= 0 ? v["option" + (frameIdx + 1)] : null; }
    var avail = (product.variants || []).filter(function (v) { return v.available && sizeArea(sizeOf(v)) != null; });
    if (!avail.length) return empty;
    var current = (product.variants || []).filter(function (v) { return String(v.id) === String(currentVariantId); })[0] || avail[0];
    var substrate = subIdx >= 0 ? (subOf(current) != null ? subOf(current) : subOf(avail[0])) : null;
    var frame = frameIdx >= 0 ? (frameOf(current) != null ? frameOf(current) : frameOf(avail[0])) : null;
    var substrates = [];
    if (subIdx >= 0) avail.forEach(function (v) { var s = subOf(v); if (s != null && substrates.indexOf(s) < 0) substrates.push(s); });
    var frames = [];
    if (frameIdx >= 0) avail.forEach(function (v) { var f = frameOf(v); if (f != null && frames.indexOf(f) < 0) frames.push(f); });
    var tokens = [];
    avail.forEach(function (v) { var t = sizeOf(v); if (tokens.indexOf(t) < 0) tokens.push(t); });
    tokens.sort(function (a, b) { return sizeArea(a) - sizeArea(b); });
    var sizes = [];
    tokens.forEach(function (t) {
      var v = sizeRowVariant(product, t, substrate, frame);
      if (!v) return;
      if (subIdx >= 0 && subOf(v) !== substrate) return;
      if (frameIdx >= 0 && frame != null && frameOf(v) !== frame) return;
      sizes.push({ token: t, price: v.price, variantId: v.id, current: sizeOf(current) === t });
    });
    return { sizes: sizes, substrates: substrates, substrate: substrate, frames: frames, frame: frame };
  }
  // G3b: ONE place moves a card onto a variant — dataset, shown price and
  // every deep link travel together, so the board add, PDP links and price
  // can never skew apart.
  // Framed integrity (user rule 2026-09-01, full page): a Framed variant on
  // a card carries NO moulding spec — the PDP builder owns that design — so
  // the page's bulk add lanes must refuse it rather than ship an
  // unspecified frame.
  function variantFramed(product, variant) {
    if (!product || !variant) return false;
    var names = (product.options || []).map(function (o) { return (o && o.name) || o; });
    var frameIdx = names.indexOf("Frame");
    if (frameIdx < 0) return false;
    var val = String(variant["option" + (frameIdx + 1)] || "");
    return !!val && !/no frame/i.test(val);
  }

  // Every PDP link on the card (stretch cover, title, bag action, View
  // piece) goes through here so they always agree. A framed card with a
  // chosen swatch carries fb_frame, so the piece page's builder opens on the
  // CARD'S moulding, not its own default (user report 2026-09-01).
  function refreshCardLinks(card, handle) {
    handle = handle || card.getAttribute("data-handle");
    if (!handle) return;
    var cfgUrl = pdpConfigUrl(handle, card.dataset.variantId || null);
    if (card.dataset.framed === "true" && card.dataset.mouldingId) {
      cfgUrl += (cfgUrl.indexOf("?") >= 0 ? "&" : "?") +
        "fb_frame=" + encodeURIComponent(card.dataset.mouldingId);
    }
    var stretchEl = card.querySelector(".cnc-card__link");
    if (stretchEl) stretchEl.href = cfgUrl;
    var goEl = card.querySelector(".cnc-card__action--cart");
    if (goEl) goEl.href = cfgUrl;
    var viewEl = card.querySelector(".cnc-card__view");
    if (viewEl) viewEl.href = cfgUrl;
    var titleEl = card.querySelector(".cnc-card__title");
    if (titleEl && titleEl.parentElement && titleEl.parentElement.tagName === "A") titleEl.parentElement.href = cfgUrl;
  }

  function applyCardVariant(card, product, variant, handle) {
    if (!variant) return;
    card.dataset.variantId = String(variant.id);
    if (variantFramed(product, variant)) card.dataset.framed = "true";
    else delete card.dataset.framed;
    var priceEl = card.querySelector(".cnc-card__price");
    if (priceEl) priceEl.textContent = formatCents(variant.price,
      (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD");
    refreshCardLinks(card, handle);
  }
  function renderSizeRow(card, product, handle) {
    var old = card.querySelector(".cnc-card__sizes"); if (old) old.remove();
    var oldSub = card.querySelector(".cnc-card__substrate"); if (oldSub) oldSub.remove();
    var oldFr = card.querySelector(".cnc-card__frames"); if (oldFr) oldFr.remove();
    var oldOpt = card.querySelector(".cnc-card__optrow"); if (oldOpt) oldOpt.remove();
    var oldMo = card.querySelector(".cnc-card__mouldings"); if (oldMo) oldMo.remove();
    var m = sizeRowModel(product, card.dataset.variantId);
    if (!m.sizes.length) return;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    var names = (product.options || []).map(function (o) { return (o && o.name) || o; });
    var subIdx = names.indexOf("Substrate");
    var frameIdx = names.indexOf("Frame");
    function subOf(v) { return subIdx >= 0 ? v["option" + (subIdx + 1)] : null; }
    function frameOf(v) { return frameIdx >= 0 ? v["option" + (frameIdx + 1)] : null; }
    function keepToken() { return (m.sizes.filter(function (s) { return s.current; })[0] || m.sizes[0]).token; }
    var row = el("div", "cnc-card__sizes");
    m.sizes.forEach(function (s) {
      // Stacked size-over-price (user direction 2026-09-01): prices line up
      // for comparison and the five size classes fit one row.
      var b = el("button", "cnc-sizebtn");
      b.appendChild(el("span", "cnc-sizebtn__size", s.token));
      b.appendChild(el("span", "cnc-sizebtn__price", formatCents(s.price, currency)));
      b.type = "button";
      b.setAttribute("aria-pressed", s.current ? "true" : "false");
      b.setAttribute("aria-label", "Size " + s.token + ", " + formatCents(s.price, currency));
      b.addEventListener("click", function () {
        applyCardVariant(card, product, sizeRowVariant(product, s.token, m.substrate, m.frame), handle);
        renderSizeRow(card, product, handle);
      });
      row.appendChild(b);
    });
    var anchorEl = card.querySelector(".cnc-card__why") || card.querySelector(".cnc-card__view");
    card.insertBefore(row, anchorEl || null);
    var lastRow = row;
    // Substrate + frame toggles share one row (user direction 2026-09-01).
    var optrow = null;
    function optRow() {
      if (!optrow) { optrow = el("div", "cnc-card__optrow"); card.insertBefore(optrow, row.nextSibling); lastRow = optrow; }
      return optrow;
    }
    if (m.substrates.length > 1) {
      var sub = el("div", "cnc-card__substrate");
      m.substrates.forEach(function (name) {
        var b = el("button", "cnc-sizebtn cnc-sizebtn--sub", name);
        b.type = "button";
        b.setAttribute("aria-pressed", name === m.substrate ? "true" : "false");
        b.setAttribute("aria-label", "Substrate " + name);
        b.addEventListener("click", function () {
          // Keep the shopper's size + frame when the substrate carries them;
          // otherwise land on that substrate's nearest available choice.
          var v = sizeRowVariant(product, keepToken(), name, m.frame);
          if (!v || (subIdx >= 0 && subOf(v) !== name)) {
            var onSub = (product.variants || []).filter(function (x) { return x.available && subOf(x) === name; })
              .slice().sort(function (a, b2) { return a.price - b2.price; })[0];
            v = onSub || v;
          }
          applyCardVariant(card, product, v, handle);
          renderSizeRow(card, product, handle);
        });
        sub.appendChild(b);
      });
      optRow().appendChild(sub);
    }
    // Moulding swatches (user direction 2026-09-01): with Framed selected the
    // card offers the size-valid moulding designs as a scrollable swatch
    // strip; the choice rides card.dataset.mouldingId into both add lanes.
    // The PDP builder stays the place for mat/glazing and the 3D preview.
    card.dataset.substrate = m.substrate || "";
    if (m.frame != null && !/no frame/i.test(String(m.frame))) {
      renderMouldingRow(card, keepToken());
    } else {
      delete card.dataset.mouldingId;
    }
    // Frame axis (user report 2026-09-01): Framed / No frame is a variant
    // choice too.
    if (m.frames.length > 1) {
      var fr = el("div", "cnc-card__frames");
      m.frames.forEach(function (name) {
        var b = el("button", "cnc-sizebtn cnc-sizebtn--frame", name);
        b.type = "button";
        b.setAttribute("aria-pressed", name === m.frame ? "true" : "false");
        b.setAttribute("aria-label", "Frame: " + name);
        b.addEventListener("click", function () {
          var v = sizeRowVariant(product, keepToken(), m.substrate, name);
          if (!v || (frameIdx >= 0 && frameOf(v) !== name)) {
            var onFrame = (product.variants || []).filter(function (x) { return x.available && frameOf(x) === name; })
              .slice().sort(function (a, b2) {
                var am = subOf(a) === m.substrate ? 0 : 1, bm = subOf(b2) === m.substrate ? 0 : 1;
                return (am - bm) || (a.price - b2.price);
              })[0];
            v = onFrame || v;
          }
          applyCardVariant(card, product, v, handle);
          renderSizeRow(card, product, handle);
        });
        fr.appendChild(b);
      });
      optRow().appendChild(fr);
    }
  }

  // Async moulding strip: catalog offerings valid for the card's size tier,
  // each a swatch chip painted with the offering's finish strip. A stale
  // resolve (card re-rendered, or flipped back to No frame) draws nothing.
  function renderMouldingRow(card, sizeToken) {
    var seq = (card._mouldSeq = (card._mouldSeq || 0) + 1);
    frameCatalog().then(function (catalog) {
      if (seq !== card._mouldSeq || !card.isConnected) return;
      if (card.dataset.framed !== "true") return;
      var tier = classifySizeTier(sizeToken);
      var substrate = card.dataset.substrate || "";
      var valid = catalog.filter(function (o) { return mouldingVisible(o, tier, substrate); });
      if (!valid.length) return;
      var current = card.dataset.mouldingId;
      if (!valid.some(function (o) { return o.fbId === current; })) {
        current = valid[0].fbId;
        card.dataset.mouldingId = current;
      }
      refreshCardLinks(card);
      var row = el("div", "cnc-card__mouldings");
      row.setAttribute("role", "group");
      row.setAttribute("aria-label", "Moulding");
      valid.forEach(function (o) {
        var b = el("button", "cnc-mouldbtn");
        b.type = "button";
        b.title = o.name || "";
        b.setAttribute("aria-label", "Moulding: " + (o.name || ""));
        b.setAttribute("aria-pressed", o.fbId === current ? "true" : "false");
        if (o.texture) b.style.backgroundImage = "url(" + JSON.stringify(o.texture).slice(1, -1) + ")";
        b.addEventListener("click", function () {
          card.dataset.mouldingId = o.fbId;
          [].forEach.call(row.children, function (x) { x.setAttribute("aria-pressed", "false"); });
          b.setAttribute("aria-pressed", "true");
          refreshCardLinks(card);
        });
        row.appendChild(b);
      });
      // The strip sits UNDER the shared option row, never inside it.
      var anchor = card.querySelector(".cnc-card__optrow") || card.querySelector(".cnc-card__sizes");
      if (anchor) anchor.parentNode.insertBefore(row, anchor.nextSibling);
      else card.appendChild(row);
    });
  }

  // Bulk-lane refusal feedback (fail-closed fallback): framing could not be
  // composed — never cart/project an unspecified frame, point at the PDP.
  function flashFrameFail(btn, n) {
    if (btn._flashT) clearTimeout(btn._flashT);
    if (btn._label == null) btn._label = btn.textContent;
    btn.textContent = "Framing unavailable for " + n + " pick" + (n === 1 ? "" : "s") + " \u2014 open the piece page";
    btn._flashT = setTimeout(function () {
      btn.textContent = btn._label; btn._label = null; btn._flashT = null;
    }, 2600);
  }

  // ---- Framed quick-add (user direction 2026-09-01) -------------------------
  // Reuses the frame-builder's own commerce contract (Model C / Decision D1):
  // the client NEVER sends a price — the framed variant carries the frame
  // price server-side, and the moulding rides as an identity that the
  // frame-line-attrs proxy turns into server-composed line properties (SKU
  // grammar + fail-closed size guard live there). The quick-add uses the
  // marketplace's FIRST moulding offering as the default design; the PDP
  // builder stays the place to change it.
  var FRAME_PROXY = "/apps/arteriel";
  // Size tier buckets — MUST mirror frame-commerce.server classifySizeTier
  // (and services/arteriel-mappers size_buckets.py). First match wins;
  // unparseable fails closed to XXXL, same as the server guard.
  var SIZE_TIERS = [["XS", 100], ["S", 200], ["M", 400], ["L", 1500], ["XL", 2500], ["XXL", 4000]];
  function classifySizeTier(sizeStr) {
    var m = String(sizeStr == null ? "" : sizeStr).replace(/\u00d7/g, "x").match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    if (!m) return "XXXL";
    var area = parseFloat(m[1]) * parseFloat(m[2]);
    if (!isFinite(area) || area <= 0) return "XXXL";
    for (var i = 0; i < SIZE_TIERS.length; i++) { if (area <= SIZE_TIERS[i][1]) return SIZE_TIERS[i][0]; }
    return "XXXL";
  }
  var frameCatalogP = null;
  function frameCatalog() {
    if (!frameCatalogP) {
      var market = (window.Shopify && window.Shopify.country) || "US";
      frameCatalogP = fetch(FRAME_PROXY + "/frame-materials?market=" + encodeURIComponent(market))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var list = (j && Array.isArray(j.materials)) ? j.materials : [];
          return list.map(function (o) {
            return {
              fbId: "rm_" + String(o.id),
              name: [o.name, o.finish].filter(Boolean)[0] || "",
              texture: o.texture_ref || o.swatchUrl || null,
              tiers: o.sizeTiers || o.size_tiers || [],
              profile: o.profile || "", category: o.category || "",
              moulding: {
                sku_suffix: o.sku_suffix || null, provider: o.provider || null,
                series: o.series || null, provider_sku: o.provider_sku || o.sku || null,
                finish: o.finish || null, material: o.material || null,
                size_tiers: o.sizeTiers || o.size_tiers || [],
              },
            };
          });
        })
        .catch(function () { return []; });
    }
    return frameCatalogP;
  }
  // Offering visibility — MUST mirror the PDP builder's visibleMaterials
  // (FrameBuilder.jsx): size tier AND substrate. The same finish ships as
  // distinct Small Cap / Large Cap / Floater mouldings, and floaters are
  // canvas-only — without the substrate gate a Paper card shows the floater
  // twin as a "duplicate" (user report 2026-09-01). No category = legacy,
  // shown everywhere.
  function mouldingVisible(o, tier, substrate) {
    if (o.tiers.length && o.tiers.indexOf(tier) < 0) return false;
    if (!o.category) return true;
    var isFloater = o.profile === "floater" || /floater/i.test(o.category);
    return /canvas/i.test(String(substrate || "")) ? isFloater : !isFloater;
  }

  // Default design per (size, substrate): the first visible offering.
  function defaultMouldingFor(catalog, size, substrate) {
    var tier = classifySizeTier(size);
    for (var i = 0; i < catalog.length; i++) {
      if (mouldingVisible(catalog[i], tier, substrate)) return catalog[i];
    }
    return null;
  }

  // Compose the framed cards' cart lines: variant + size + default moulding
  // -> ONE frame-line-attrs POST (positionally aligned) -> line properties.
  // Rejects when the frame cannot be composed; callers fall back to the
  // refusal flash — a bare framed line must never reach the cart or a project.
  function composeFramedItems(cards) {
    if (!cards.length) return Promise.resolve([]);
    return frameCatalog().then(function (catalog) {
      if (!catalog.length) throw new Error("no_moulding");
      return Promise.all(cards.map(function (c) {
        return fetch("/products/" + encodeURIComponent(c.getAttribute("data-handle")) + ".js")
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var vid = Number(c.dataset.variantId);
            var v = (p.variants || []).filter(function (x) { return x.id === vid; })[0];
            if (!v) throw new Error("no_variant");
            var names = (p.options || []).map(function (o) { return (o && o.name) || o; });
            var sizeIdx = Math.max(0, names.indexOf("Size"));
            return { size: v["option" + (sizeIdx + 1)], variant_id: vid };
          });
      })).then(function (items) {
        var defs = items.map(function (it, i) {
          // Card-chosen moulding wins while still visible for the size AND
          // substrate; otherwise the per-config default (the strip's rule).
          var chosen = cards[i].dataset.mouldingId;
          var substrate = cards[i].dataset.substrate || "";
          var tier = classifySizeTier(it.size);
          var hit = chosen && catalog.filter(function (o) {
            return o.fbId === chosen && mouldingVisible(o, tier, substrate);
          })[0];
          return hit || defaultMouldingFor(catalog, it.size, substrate);
        });
        if (defs.some(function (d) { return !d; })) throw new Error("no_moulding_for_size");
        return fetch(FRAME_PROXY + "/frame-line-attrs", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            scope: "arteriel",
            items: items.map(function (it, i) {
              return { size: it.size, variant_id: it.variant_id, moulding: defs[i].moulding };
            }),
          }),
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || !Array.isArray(j.items)) throw new Error("frame_attrs_failed");
            return items.map(function (it, i) {
              var props = {};
              ((j.items[i] || {}).attributes || []).forEach(function (a) { props[a.key] = a.value; });
              return { id: it.variant_id, quantity: 1, properties: props, _fbId: defs[i].fbId };
            });
          });
        });
      });
    });
  }

  function pdpConfigUrl(handle, variantId) {
    var base = "/products/" + encodeURIComponent(handle);
    return variantId ? base + "?variant=" + encodeURIComponent(String(variantId)) : base;
  }

  // pageContext mirrored in assets/concierge-helpers.mjs; keep in sync.
  function pageContext(root) {
    if (!root || !root.getAttribute) return null;
    var type = root.getAttribute("data-ctx-type") || "";
    if (type !== "product" && type !== "collection") return null;
    var out = { type: type };
    ["handle", "title", "artist"].forEach(function (k) {
      var v = (root.getAttribute("data-ctx-" + k) || "").trim().slice(0, 200);
      if (v) out[k] = v;
    });
    return out;
  }

  // --- Wall Space Designer "Change this wall" mode (design-agent PR 4b) ---------
  // mirrored in assets/concierge-helpers.mjs; keep in sync.
  var SPACE_ASK = "arteriel:space-ask", SPACE_REPLY = "arteriel:space-reply", SPACE_PING = "arteriel:space-ping", SPACE_READY = "arteriel:space-ready";
  var SPACE_NO_ANSWER = "The wall didn't answer — try the box under the arrangement.";
  var SPACE_PLACEHOLDER = "Tell me what to change — \"make the middle one bigger\", \"swap the left piece for something warmer\"…";
  function spaceAskMessage(id, text) { return { type: SPACE_ASK, id: id, utterance: String(text || "").trim().slice(0, 400) }; }
  function sameWindow(event, win) { return !!(event && event.source === win && event.origin === win.location.origin && event.data && typeof event.data === "object"); }
  function isSpaceReply(event, win, id) { return sameWindow(event, win) && event.data.type === SPACE_REPLY && event.data.id === id; }
  /** What the drawer keeps from a space reply. `proposal`/`count` are new (owner item 10); a reply
   *  from an older designer carries neither, and is simply not a proposal. */
  function spaceReplyOutcome(data) {
    var d = data || {};
    var n = Math.trunc(Number(d.count));
    return { ok: !!d.ok, reply: String(d.reply || ""), proposal: !!d.proposal, count: n > 0 ? n : 0 };
  }
  function askDesigner(win, text, timeoutMs, makeId) {
    var id = (makeId || function () { return String(Date.now()) + Math.random().toString(36).slice(2); })();
    return new Promise(function (resolve) {
      var timer = null;
      function done(r) { win.removeEventListener("message", onMsg); if (timer) clearTimeout(timer); resolve(r); }
      function onMsg(e) { if (isSpaceReply(e, win, id)) done(spaceReplyOutcome(e.data)); }
      win.addEventListener("message", onMsg);
      timer = setTimeout(function () { done({ ok: false, reply: SPACE_NO_ANSWER, timeout: true, proposal: false, count: 0 }); }, timeoutMs == null ? 20000 : timeoutMs);
      win.postMessage(spaceAskMessage(id, text), win.location.origin);
    });
  }
  function pingDesigner(win, timeoutMs) {
    return new Promise(function (resolve) {
      var timer = null;
      function done(v) { win.removeEventListener("message", onMsg); if (timer) clearTimeout(timer); resolve(v); }
      function onMsg(e) { if (sameWindow(e, win) && e.data.type === SPACE_READY) done(true); }
      win.addEventListener("message", onMsg);
      timer = setTimeout(function () { done(false); }, timeoutMs == null ? 1500 : timeoutMs);
      win.postMessage({ type: SPACE_PING }, win.location.origin);
    });
  }
  function spaceModeState(s) { var show = !!s.hasDesigner; return { show: show, on: show && !!s.ready && s.pressed !== false }; }

  /* --- owner item 10: the drawer's way back to the cards the designer laid down behind it ---------
     In SPACE MODE the drawer renders only the one-line reply; the 6-24 pick cards land in the
     designer's thread. Since every find-ask became a 24-piece proposal the drawer read as empty.
     mirrored in assets/concierge-helpers.mjs; keep in sync. */

  /** The secondary action's copy. Short, and it names the count only when the designer sent one. */
  function spaceProposalLabel(count) {
    var n = Math.trunc(Number(count));
    if (!(n > 0)) return "Show me →";
    return n === 1 ? "Show me the piece →" : "Show me the " + n + " pieces →";
  }

  /** Close the drawer, then bring the designer's thread into view. Returns what it scrolled to. */
  function revealDesignerProposal(doc, close) {
    if (typeof close === "function") close();
    var target = doc ? doc.querySelector(".sd-thread-list") || doc.querySelector("[data-space-designer]") : null;
    if (target && typeof target.scrollIntoView === "function") target.scrollIntoView({ block: "start", behavior: "smooth" });
    return target || null;
  }


  function searchCarryLink(brief, lastSearch, convId) {
    var a = el("a", "cnc-carry", "Limit reached — see these matches in search →");
    a.href = carrySearchUrl(brief, lastSearch, convId);
    return a;
  }

  // The way out must survive the turn that produced it (spec §6.4).
  function noteLastSearch(state, ls) { if (ls) state.lastSearch = ls; }

  // onBoot (optional, guided capture — D1): called once with the full boot
  // body ({quota, conversations, prefs, mode, ...}) on a 200, or null on any
  // failure/anon-skip — always called, so a caller can wire capture-trigger
  // off it and degrade gracefully when the platform lags or the call fails.
  function initMeter(root, node, signedIn, onBoot) {
    if (!signedIn) {
      if (node) renderMeter(node, null, false, root, false);
      if (onBoot) onBoot(null);
      return;
    }
    api(root, "/concierge/conversations").then(function (r) {
      if (r.status === 200) {
        if (node && r.body.quota) renderMeter(node, r.body.quota, true, root);
        if (onBoot) onBoot(r.body);
      } else if (onBoot) onBoot(null);
    }).catch(function () { if (onBoot) onBoot(null); });
  }

  function trapFocus(container) {
    container.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var els = container.querySelectorAll('button, [href], input, [contenteditable="true"]');
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // Sign-in lock card removed (user direction 2026-09-01, mobile redesign):
  // the anon preview keeps its blurred cards; the meter line carries sign-in.

  // "See all matches" CTA (Task 6, guided capture): links out to /search with
  // the exact query+facets the concierge's last search_catalog call used
  // (turn.last_search — Task 5 platform contract, dict | null; absent/null on
  // old payloads renders no CTA). searchUrl mirrored in
  // assets/concierge-helpers.mjs (node --test); keep in sync. Param
  // names/order and the comma-joined-array convention are taken directly
  // from assets/ai-search.js's FILTER_KEYS (verified against that file, not
  // guessed): artist, medium, style, theme, colour, size_class, price_band,
  // format, plus "q" for the free-text query. Any other key the model might
  // emit (the search-tool-only "note"/"limit") is dropped rather than guessed
  // at. Shape keys are the exception — see the normaliser below.
  // Shape translation (verified 2026-09-13). The concierge search tool spells a
  // square work `orientation: "square"` (concierge_core.py:284-287) and stores
  // the RAW tool input in last_search, but /search accepts only
  // portrait|landscape for `orientation`, spells square as `family=A`
  // (artwork_search_proxy.py:131-132), and answers anything else with 400 "bad
  // parameter" (ai_search/handler.py:122-123). Every emission of a LAST_SEARCH
  // facet — the See-all URL, the over-quota carry URL and the reply-markup
  // facet links — goes through this one normaliser, or the concierge mints
  // links that break the public floor. The other two /search emitters in this
  // file (the facet-vocabulary pass in replyMarkupModel, and replyGlance) do
  // NOT, and are safe only because their key lists are hard-coded and
  // shape-free; both carry a note saying so.
  // Mirrored in assets/concierge-helpers.mjs; keep in sync.
  var SEARCH_FILTER_KEYS = ["artist", "medium", "style", "theme", "colour",
                            "size_class", "price_band", "format", "orientation", "family"];
  var VALID_ORIENTATIONS = ["portrait", "landscape"];
  var VALID_FAMILIES = ["A", "B", "C", "D", "E"];

  // searchFilterParam mirrored in assets/concierge-helpers.mjs; keep in sync.
  function searchFilterParam(key, value) {
    var s = String(value == null ? "" : value).trim();
    if (!s) return null;
    if (key === "orientation") {
      if (s === "square") return { key: "family", value: "A" };
      return VALID_ORIENTATIONS.indexOf(s) >= 0 ? { key: "orientation", value: s } : null;
    }
    if (key === "family") {
      return VALID_FAMILIES.indexOf(s) >= 0 ? { key: "family", value: s } : null;
    }
    return { key: key, value: s };
  }

  function searchUrl(lastSearch, conversationId) {
    if (!lastSearch) return null;
    var p = new URLSearchParams();
    if (lastSearch.query) p.set("q", String(lastSearch.query));
    var byKey = {};
    SEARCH_FILTER_KEYS.forEach(function (k) {
      var v = lastSearch[k];
      if (v == null) return;
      (Array.isArray(v) ? v : [v]).forEach(function (raw) {
        var norm = searchFilterParam(k, raw);
        if (!norm) return;
        var bucket = byKey[norm.key] || (byKey[norm.key] = []);
        if (bucket.indexOf(norm.value) < 0) bucket.push(norm.value);
      });
    });
    SEARCH_FILTER_KEYS.forEach(function (k) { if (byKey[k] && byKey[k].length) p.set(k, byKey[k].join(",")); });
    if (!p.toString()) return null;
    // Spec §6.4: /search hands the conversation back on its "Ask the
    // concierge" link, so the return trip resumes by ?c= instead of re-asking
    // the brief.
    if (conversationId) p.set("c", String(conversationId));
    return "/search?" + p.toString();
  }

  // Spec §6.3: over quota the link used the RAW brief text and discarded the
  // facets. A 429 arrives BEFORE the turn runs (quota is spent when a
  // conversation is created, handler.py:139), so the facets in hand are the
  // last completed turn's — better than a keyword guess, and with none this
  // degrades to exactly today's URL. Mirrored in assets/concierge-helpers.mjs.
  function carrySearchUrl(brief, lastSearch, conversationId) {
    var q = String(brief || "").slice(0, 200);
    var merged = Object.assign({}, lastSearch || {});
    if (q) merged.query = q;
    var url = searchUrl(merged, conversationId);
    if (url) return url;
    var p = new URLSearchParams();
    if (q) p.set("q", q);
    if (conversationId) p.set("c", String(conversationId));
    var s = p.toString();
    return s ? "/search?" + s : "/search";
  }

  // Spec §6 + the plan's Global Constraint "search is the public floor and is
  // never gated". The page's selection header hides when the canvas is empty —
  // the I3 dead-handle path (every pick 404s, set-row and grid removed,
  // updateSelhead(0)) and a rehydrated conversation whose final turn is prose
  // only. That header also holds the ONLY permanent way out to /search, so an
  // available search-all link is a SECOND, independent reason to render it:
  // hiding the sole exit is itself a gate. `hasSelection` is the other half:
  // everything in the header that SPEAKS FOR a selection — the "Selection · n
  // works" eyebrow, "Add set to cart", the trade project picker and its save
  // button — is meaningless on an empty canvas, and a visibly inert control
  // invites a click that silently does nothing. A header retained only to host
  // the exit link shows only the exit link.
  // Mirrored in assets/concierge-helpers.mjs.
  function selheadView(total, hasSearchAll) {
    var n = Number(total) || 0;
    return { hidden: !n && !hasSearchAll, hasSelection: n > 0 };
  }

  // Everything in .cnc-selhead that speaks for a selection (Ruling 27). The
  // eyebrow carries the count; the last two exist only on the trade branch.
  var SELHEAD_SELECTION_PARTS = ["[data-cnc-seleyebrow]", "[data-cnc-addset]",
                                 "[data-cnc-selhead-project]", "[data-cnc-saveproject]"];

  // Renders `a.cnc-seeall` after the picks row, or nothing when the turn
  // carried no (or an empty) last_search — plain navigation, no target=_blank.
  function renderSeeAll(container, lastSearch, pageHref, convId) {
    // Drawer contract (user report 2026-09-01): "See all" must show the
    // AGENT'S full shortlist — the concierge page rehydrates every pick on
    // the canvas via ?c=. The /search deep-link (this turn's catalog
    // matches) stays as the anon fallback and the page-side meaning.
    if (pageHref) {
      var pick = el("a", "cnc-seeall", "See all picks \u2192");
      pick.href = pageHref;
      container.appendChild(pick);
      return;
    }
    var href = searchUrl(lastSearch, convId);
    if (!href) return;
    var link = el("a", "cnc-seeall", "See all matches in search");
    link.href = href;
    container.appendChild(link);
  }

  // Rehydrate walk-back (live bug fix, user-reported): the ?c=/History
  // restore paths must not blank the canvas when the conversation's FINAL
  // turn is prose-only (zero picks — e.g. a closing "which is right for your
  // sideboard" answer) but an earlier turn carried picks.
  // lastPicksTurn mirrored in assets/concierge-helpers.mjs; keep in sync.
  // parseModelMarkup mirrored in assets/concierge-helpers.mjs; keep in sync.
  function parseModelMarkup(raw) {
    var src = String(raw || "");
    var text = "";
    var bold = [];
    var i = 0, open = -1;
    while (i < src.length) {
      if (src.slice(i, i + 2) === "**") {
        if (open < 0) open = text.length;
        else if (text.length > open) { bold.push({ start: open, end: text.length }); open = -1; }
        else open = text.length;
        i += 2;
      } else { text += src[i]; i += 1; }
    }
    if (open >= 0) text = text.slice(0, open) + "**" + text.slice(open);
    return { text: text, bold: bold };
  }
  // replyMarkupModel mirrored in assets/concierge-helpers.mjs; keep in sync.
  function replyMarkupModel(text, lastSearch, picks, vocab) {
    var pm = parseModelMarkup(text);
    var t = pm.text;
    if (!t) return [];
    var marks = [];
    function push(start, end, href) {
      if (start < 0 || end <= start) return;
      for (var i = 0; i < marks.length; i++) if (start < marks[i].end && end > marks[i].start) return;
      marks.push({ start: start, end: end, href: href || null });
    }
    var q = /[\u201c"]([^\u201d"]{2,60})[\u201d"]/g;
    var m;
    while ((m = q.exec(t))) {
      var inner = m[1];
      var start = m.index + 1;
      var words = inner.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2; });
      var href = null;
      (picks || []).forEach(function (p) {
        if (href || !p || !p.handle) return;
        var hdl = String(p.handle).toLowerCase();
        var all = words.length > 0;
        words.forEach(function (w) { if (hdl.indexOf(w) < 0) all = false; });
        if (all) href = "/products/" + encodeURIComponent(p.handle);
      });
      push(start, start + inner.length, href);
    }
    // Unquoted title references — mirrored from helpers; keep in sync.
    (picks || []).forEach(function (p) {
      if (!p || !p.handle) return;
      var words = String(p.handle).split("-").filter(function (w) { return /^[a-z]{3,}$/i.test(w); });
      for (var len = Math.min(words.length, 6); len >= 2; len--) {
        var found = false;
        for (var i2 = 0; i2 + len <= words.length; i2++) {
          var phrase = words.slice(i2, i2 + len).join(" ");
          var re2 = new RegExp(phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "ig");
          var mm2;
          while ((mm2 = re2.exec(t))) {
            var a2 = t[mm2.index - 1], b2 = t[mm2.index + phrase.length];
            if ((a2 && /[A-Za-z0-9]/.test(a2)) || (b2 && /[A-Za-z0-9]/.test(b2))) continue;
            push(mm2.index, mm2.index + phrase.length, "/products/" + encodeURIComponent(p.handle));
            found = true;
          }
        }
        if (found) break;
      }
    });
    // Facet-vocabulary pass — mirrored from helpers; keep in sync.
    // NOTE: hard-coded and deliberately SHAPE-FREE. Adding "orientation" or
    // "family" here without routing the href through searchFilterParam
    // re-introduces the 400 on /search.
    if (vocab) ["artist", "style", "theme", "colour", "medium"].forEach(function (k) {
      (vocab[k] || []).forEach(function (val) {
        var s = String(val);
        if (s.length < 3) return;
        var re = new RegExp(s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "s?", "ig");
        var mm;
        while ((mm = re.exec(t))) {
          var a = t[mm.index - 1], b = t[mm.index + mm[0].length];
          if ((a && /[A-Za-z0-9]/.test(a)) || (b && /[A-Za-z0-9]/.test(b))) continue;
          push(mm.index, mm.index + mm[0].length, "/search?" + k + "=" + encodeURIComponent(s));
          if (k !== "artist") break;
        }
        if (k === "artist") {
          var parts = s.split(/\s+/);
          var sur = parts.length > 1 ? parts[parts.length - 1] : "";
          if (sur.length >= 4) {
            var re2 = new RegExp(sur.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g");
            var m2;
            while ((m2 = re2.exec(t))) {
              var a2 = t[m2.index - 1], b2 = t[m2.index + sur.length];
              if ((a2 && /[A-Za-z0-9]/.test(a2)) || (b2 && /[A-Za-z0-9]/.test(b2))) continue;
              push(m2.index, m2.index + sur.length, "/search?" + k + "=" + encodeURIComponent(s));
            }
          }
        }
      });
    });
    SEARCH_FILTER_KEYS.forEach(function (k) {
      var v = lastSearch && lastSearch[k];
      (Array.isArray(v) ? v : [v]).forEach(function (val) {
        if (val == null) return;
        var s = String(val);
        if (s.length < 3) return;
        // The shopper reads "square"; the link must say family=A or /search 400s.
        var norm = searchFilterParam(k, s);
        if (!norm) return;
        var re = new RegExp(s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "ig");
        var mm;
        while ((mm = re.exec(t))) {
          var a = t[mm.index - 1], b = t[mm.index + s.length];
          if ((a && /[A-Za-z0-9]/.test(a)) || (b && /[A-Za-z0-9]/.test(b))) continue;
          push(mm.index, mm.index + s.length, "/search?" + norm.key + "=" + encodeURIComponent(norm.value));
          break;
        }
      });
    });
    // Model-emitted emphasis last: bold where no link already claimed the span.
    pm.bold.forEach(function (r) { push(r.start, r.end, null); });
    if (!marks.length) return [{ text: t }];
    marks.sort(function (x, y) { return x.start - y.start; });
    var out = [];
    var pos = 0;
    marks.forEach(function (mk) {
      if (mk.start > pos) out.push({ text: t.slice(pos, mk.start) });
      var seg = { text: t.slice(mk.start, mk.end) };
      if (mk.href) seg.href = mk.href; else seg.strong = true;
      out.push(seg);
      pos = mk.end;
    });
    if (pos < t.length) out.push({ text: t.slice(pos) });
    return out;
  }
  // Segments -> DOM nodes only (model text is DATA; no innerHTML ever).
  // Renders immediately with whatever vocabulary is loaded; a reply painted
  // before the shop vocab arrives re-renders once it lands.
  function applyReplyMarkup(p, text, lastSearch, picks) {
    function render(vocab) {
      while (p.firstChild) p.removeChild(p.firstChild);
      replyMarkupModel(text, lastSearch, picks, vocab).forEach(function (seg) {
        if (seg.href) {
          var a = el("a", "cnc-hl", seg.text);
          a.href = seg.href;
          a.target = "_blank";
          a.rel = "noopener";
          p.appendChild(a);
        } else if (seg.strong) {
          p.appendChild(el("strong", "cnc-hl", seg.text));
        } else {
          p.appendChild(document.createTextNode(seg.text));
        }
      });
    }
    render(FACET_VOCAB);
    if (!FACET_VOCAB && vocabPromise) vocabPromise.then(function (v) { if (v) render(v); });
  }
  // replyGlance mirrored in assets/concierge-helpers.mjs; keep in sync.
  function replyGlance(reply, lastSearch, picks, vocab) {
    reply = parseModelMarkup(reply).text;
    var out = [];
    var n = (picks || []).length;
    if (n) out.push({ text: n + (n === 1 ? " work" : " works") });
    var t = String(reply || "");
    var artists = 0;
    if (vocab && t) (vocab.artist || []).forEach(function (name) {
      if (artists >= 2) return;
      var s = String(name);
      var parts = s.split(/\s+/);
      var sur = parts.length > 1 ? parts[parts.length - 1] : "";
      var hit = new RegExp(s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i").test(t)
        || (sur.length >= 4 && t.indexOf(sur) >= 0);
      if (hit) { artists++; out.push({ text: s, href: "/search?artist=" + encodeURIComponent(s) }); }
    });
    // NOTE: hard-coded and deliberately SHAPE-FREE. Adding "orientation" or
    // "family" here without routing the href through searchFilterParam
    // re-introduces the 400 on /search.
    ["style", "theme", "colour", "medium", "format"].forEach(function (k) {
      var v = lastSearch && lastSearch[k];
      (Array.isArray(v) ? v : [v]).forEach(function (val) {
        if (val == null || String(val) === "" || out.length >= 7) return;
        out.push({ text: String(val), href: "/search?" + k + "=" + encodeURIComponent(String(val)) });
      });
    });
    return out;
  }
  // The digest line ABOVE each reply: what it is, who it's by, what to
  // search next — the sellable facts before the prose.
  function renderGlance(container, reply, lastSearch, picks) {
    var box = el("p", "cnc-glance");
    function render(vocab) {
      while (box.firstChild) box.removeChild(box.firstChild);
      var toks = replyGlance(reply, lastSearch, picks, vocab);
      box.hidden = !toks.length;
      toks.forEach(function (tk, i) {
        if (i) box.appendChild(document.createTextNode(" \u00b7 "));
        if (tk.href) {
          var a = el("a", "cnc-glance__t", tk.text);
          a.href = tk.href; a.target = "_blank"; a.rel = "noopener";
          box.appendChild(a);
        } else box.appendChild(el("span", "cnc-glance__t", tk.text));
      });
    }
    render(FACET_VOCAB);
    if (!FACET_VOCAB && vocabPromise) vocabPromise.then(function (v) { if (v) render(v); });
    container.appendChild(box);
  }

  function lastPicksTurn(turns) {
    var list = turns || [];
    for (var i = list.length - 1; i >= 0; i--) {
      if (((list[i] && list[i].picks) || []).length > 0) return list[i];
    }
    return null;
  }

  // --- guided input (sketch 002 + mobile friction fix 2026-08-31) -----------
  // seedText / moreLikeSeed / formatCents / quickPrompts mirrored in assets/concierge-helpers.mjs (node --test); keep in sync.
  // Redesign vocabulary (PDF p1): size adjustment moved onto the cards
  // (G3b size row), so the refiners speak palette + medium.
  var REFINERS = ["warmer", "cooler", "more prints", "fewer oils"];

  function formatCents(cents, currency) {
    if (cents == null) return "";
    try {
      return new Intl.NumberFormat("en", { style: "currency", currency: currency || "USD" })
        .format(cents / 100);
    } catch { return "$" + (cents / 100).toFixed(2); }
  }

  // gridCapModel mirrored in assets/concierge-helpers.mjs; keep in sync.
  var PICK_CAPS = { retail: 12, trade: 24 };
  var COLLAPSED_PICKS = { retail: 6, trade: 12 };
  var COLLAPSED_PICKS_PHONE = { retail: 4, trade: 6 };

  function gridCapModel(n, mode, phone) {
    var cap = PICK_CAPS[mode] || PICK_CAPS.retail;
    var collapsedBy = phone ? COLLAPSED_PICKS_PHONE : COLLAPSED_PICKS;
    var total = Math.max(0, Math.min(n || 0, cap));
    var shown = Math.min(total, collapsedBy[mode] || collapsedBy.retail);
    return { total: total, shown: shown, more: total - shown };
  }

  // INLINE_STRIP_COUNT / setRowTitle mirrored in assets/concierge-helpers.mjs; keep in sync.
  var INLINE_STRIP_COUNT = 6;

  function setRowTitle(total, shown) {
    return total > shown ? "Top " + shown + " of " + total : "Your shortlist";
  }

  // shortlistTitle mirrored in assets/concierge-helpers.mjs; keep in sync.
  // Residual 4: the set-row label is built from the RAW picks array before the
  // hydrate is awaited, but X19 drops dead handles during hydration — so 8
  // picks with 3 bad handles announced "Top 6 of 8" over 5 cards. `shown` must
  // be the cards that actually rendered. `total` drops only the deaths we
  // actually observed: the head is all that hydrates (spec §5.4), so the
  // remainder stays an optimistic upper bound, exactly the convention the page
  // canvas already uses for updateSelhead.
  function shortlistTitle(totalPicks, headCount, rendered) {
    var shown = rendered || 0;
    var dead = Math.max(0, (headCount || 0) - shown);
    return setRowTitle(Math.max(shown, (totalPicks || 0) - dead), shown);
  }

  // Corrects the set-row label in place once hydration is done. Update-AFTER
  // rather than defer: both call sites append the set-row BEFORE the awaited
  // hydrate on purpose, so the shortlist holds its scrollback position (X19).
  // Deferring the row until the cards resolve would put that layout jump back,
  // so the row renders an optimistic label and is corrected here.
  function retitleShortlist(setrow, totalPicks, headCount, rendered) {
    if (!setrow) return;
    var title = setrow.querySelector(".cnc-settitle");
    if (title) title.textContent = shortlistTitle(totalPicks, headCount, rendered);
  }

  function seedText(current, fragment) {
    return ((current || "") + " " + fragment + ";").trim();
  }

  function moreLikeSeed(title, artist, n) {
    return title ? 'more like "' + title + '"' + (artist ? " by " + artist : "") : "more like pick " + n;
  }

  var PROMPT_PATTERNS = [
    /narrow these by\s+(.+)\?$/i,
    /compare\s+(.+)\?$/i,
    /:\s*([^:]+)\?$/,           // "closest to your room: a, b, or c?"
    /would you like\s+(?:to see\s+)?(.+)\?$/i,
  ];

  function quickPrompts(reply) {
    if (!reply) return [];
    // Lookbehind-free equivalent of split(/(?<=[.?!])\s+/) + last-element pick —
    // the lookbehind form crashes the whole file on iOS <=16.3 (I3).
    var lastMatch = reply.trim().match(/(?:^|[.?!]\s+)([^.?!]*\?)$/);
    var last = lastMatch ? lastMatch[1] : "";
    if (!last.endsWith("?")) return [];
    var body = null;
    for (var i = 0; i < PROMPT_PATTERNS.length; i++) {
      var m = last.match(PROMPT_PATTERNS[i]);
      if (m) { body = m[1]; break; }
    }
    if (!body) return [];
    var parts = body.indexOf(",") !== -1 ? body.split(",") : body.split(/\s+or\s+/i);
    if (parts.length < 2) return [];
    return parts.map(function (s) { return s.trim().replace(/^or\s+/i, "").replace(/[.?]$/, ""); })
      .filter(function (s) { return s && s.length <= 40; }).slice(0, 4);
  }

  function seedChip(input, fragment, onSeed) {
    input.textContent = seedText(input.textContent, fragment);
    if (onSeed) onSeed();
    input.focus();
  }

  function bindChips(root, input, onSeed) {
    root.querySelectorAll("[data-cnc-chip]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        chip.setAttribute("aria-pressed", chip.getAttribute("aria-pressed") === "true" ? "false" : "true");
        seedChip(input, chip.textContent, onSeed);
      });
    });
  }

  // Tappable follow-ups under a reply: refiners + grounded "More like #N" chips.
  // Title/artist are read from the hydrated card dataset AT CLICK TIME (hydration
  // is async), so the seed needs no backend ordinal parsing.
  function renderFollowups(container, cards, input, onSeed, submit) {
    container.appendChild(el("p", "cnc-followups__label", "Adjust the selection"));
    var row = el("div", "cnc-followups");
    REFINERS.forEach(function (word) {
      var b = el("button", submit ? "cnc-chip cnc-chip--send" : "cnc-chip", word);
      b.type = "button";
      // Mobile redesign (design p2): a refinement chip SENDS as a turn;
      // initial preference chips are untouched — capture builds the brief.
      b.addEventListener("click", function () {
        if (submit) submit(word);
        else seedChip(input, word, onSeed);
      });
      row.appendChild(b);
    });
    (cards || []).forEach(function (card, i) {
      var b = el("button", submit ? "cnc-chip cnc-chip--send" : "cnc-chip", "More like #" + (i + 1));
      b.type = "button";
      b.addEventListener("click", function () {
        if (submit) submit(moreLikeSeed(card.dataset.title, card.dataset.artist, i + 1));
        else seedChip(input, moreLikeSeed(card.dataset.title, card.dataset.artist, i + 1), onSeed);
      });
      row.appendChild(b);
    });
    container.appendChild(row);
  }

  // Reply feedback (CV-B2): 👍/👎 posted to the feedback route, keyed by
  // conversation_id + seq (derived client-side from the turn_id "id:seq" shape
  // for live turns; carried straight through on rehydrated turns).
  // turnSeq mirrored in assets/concierge-helpers.mjs; keep in sync.
  function turnSeq(turnId) {
    return parseInt(String(turnId).split(":").pop(), 10);
  }

  var REASON_CHIPS = ["Wrong palette", "Wrong scale", "Too similar", "Off style", "Over budget"];

  function renderFeedback(container, root, conversationId, seq, current, currentReason) {
    // Panel v2: "Was this helpful?" + Helpful / Not helpful pills; a down
    // verdict opens one row of reason chips ("What missed? This tunes the
    // next set.") — reason rides the same feedback POST (platform additive).
    var wrap = el("div", "cnc-feedback");
    var prompt = el("span", "cnc-feedback__prompt", "");
    wrap.appendChild(prompt);
    var fb = { verdict: current || null, reason: currentReason || null };
    var reasons = el("div", "cnc-reasons");
    reasons.hidden = true;
    function sync() {
      prompt.textContent = fb.verdict === "up" ? "Thanks \u2014 noted for next time."
        : fb.verdict === "down" ? (fb.reason ? "Thanks \u2014 I'll weight that." : "Tell me what missed:")
        : "Was this helpful?";
      up.setAttribute("aria-pressed", fb.verdict === "up" ? "true" : "false");
      down.setAttribute("aria-pressed", fb.verdict === "down" ? "true" : "false");
      reasons.hidden = fb.verdict !== "down";
      reasons.querySelectorAll(".cnc-reason").forEach(function (b) {
        b.setAttribute("aria-pressed", b.textContent === fb.reason ? "true" : "false");
      });
    }
    function send(verdict, reason) {
      var prev = { verdict: fb.verdict, reason: fb.reason };
      fb.verdict = verdict; fb.reason = reason || null;
      sync();
      function revert() { fb.verdict = prev.verdict; fb.reason = prev.reason; sync(); }
      api(root, "/concierge/feedback", { method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ conversation_id: conversationId, seq: seq, verdict: verdict,
                              reason: reason || undefined }) })
        .then(function (r) { if (r.status !== 200) revert(); })
        .catch(revert);
    }
    var up = el("button", "cnc-feedback__btn", "Helpful");
    up.type = "button"; up.setAttribute("aria-label", "Helpful");
    up.addEventListener("click", function () { send("up"); });
    var down = el("button", "cnc-feedback__btn", "Not helpful");
    down.type = "button"; down.setAttribute("aria-label", "Not helpful");
    down.addEventListener("click", function () { send("down", fb.reason); });
    wrap.appendChild(up); wrap.appendChild(down);
    container.appendChild(wrap);
    reasons.appendChild(el("span", "cnc-reasons__note", "What missed? This tunes the next set."));
    REASON_CHIPS.forEach(function (label) {
      var b = el("button", "cnc-reason", label);
      b.type = "button";
      b.addEventListener("click", function () { send("down", fb.reason === label ? null : label); });
      reasons.appendChild(b);
    });
    container.appendChild(reasons);
    sync();
  }

  // One-tap send chips parsed from a closing question in the reply (CV-3).
  // Results-first (2026-09-07): the shortlist renders BEFORE the reply prose in the drawer —
  // "Top 6 of N" row + six cards — so the reply reads as commentary on what is shown
  // and the bold titles in it resolve visually.
  // Builds the set-row label + "see all" link and returns the top INLINE_STRIP_COUNT
  // picks for the caller to hydrate (X19: fetching/appending the cards themselves
  // is the caller's job now, so a container can be appended before the await);
  // [] when the turn carries no picks (policy answers, questions: prose only).
  function renderPicksBlock(thread, picks, lastSearch, seeAllHref, ctx, convId) {
    if (!(picks || []).length) return [];
    var setrow = el("div", "cnc-setrow");
    setrow.appendChild(el("p", "cnc-settitle", setRowTitle(picks.length, INLINE_STRIP_COUNT)));
    renderSeeAll(setrow, lastSearch, seeAllHref, convId);
    thread.appendChild(setrow);
    return picks.slice(0, INLINE_STRIP_COUNT);
  }

  function renderQuickPrompts(container, reply, submit) {
    var opts = quickPrompts(reply);
    if (!opts.length) return;
    var row = el("div", "cnc-followups cnc-quickrow");
    opts.forEach(function (opt) {
      var b = el("button", "cnc-chip cnc-chip--send", opt);
      b.type = "button";
      b.addEventListener("click", function () { submit("Show " + opt); });
      row.appendChild(b);
    });
    container.appendChild(row);
  }

  // --- workspace continuity (2026-08-31) -------------------------------------
  var STORE_KEY = "cnc:conversation";
  function storedConversation() { try { return sessionStorage.getItem(STORE_KEY) || null; } catch (e) { return null; } }
  function storeConversation(id) { try { if (id) sessionStorage.setItem(STORE_KEY, id); } catch (e) {} }
  function clearConversation() { try { sessionStorage.removeItem(STORE_KEY); } catch (e) {} }

  // --- trade chrome (Phase B Task 12, 2026-09-01) ---------------------------
  // Project rail + board select + sticky boardbar. Server mode is the
  // authority (wired from the boot call); retail hard-returns. Mounts exist
  // only on the page surface — the drawer is untouched.
  var tradeRailDone = false;
  // ——— Shared history view (full-page redesign 2026-09-01) ———
  // ONE implementation serves the drawer and the page: grouped rows,
  // deferred delete with a 6s undo, Delete all, and the exclusive-view pill
  // contract (History <-> Back, cnc--history hides the composer). Surface
  // specifics — how a conversation rehydrates, what Start fresh rebuilds —
  // arrive as callbacks in `o`.
  function initHistoryView(root, o) {
    var conversations = [];
    // History is an EXCLUSIVE view (user direction 2026-09-01): tracked open
    // state drives the pill label (History <-> Back) and the cnc--history
    // class that hides the composer.
    function setHistoryOpen(on) {
      o.state.historyOpen = on;
      root.classList.toggle("cnc--history", on);
      if (o.historyBtn) {
        o.historyBtn.textContent = on ? "Back" : "History";
        o.historyBtn.classList.toggle("cnc-drawer__action--active", on);
      }
      if (o.onExclusive) o.onExclusive(on);
    }
    // Panel v2: history deletion is DEFERRED — rows leave immediately, the
    // server DELETE fires only when the undo window passes (or on the next
    // action / pagehide, with keepalive). Undo restores the snapshot.
    var pendingDeletes = [];
    var undoTimer = null;
    var UNDO_MS = 6000;
    function flushPendingDeletes() {
      if (undoTimer) { clearTimeout(undoTimer); undoTimer = null; }
      var ids = pendingDeletes; pendingDeletes = [];
      if (o.undoBox) { o.undoBox.hidden = true; while (o.undoBox.firstChild) o.undoBox.removeChild(o.undoBox.firstChild); }
      ids.forEach(function (id) {
        api(root, "/concierge/conversation/" + encodeURIComponent(id), { method: "DELETE", keepalive: true })
          .catch(function () {});
      });
    }
    function queueUndo(ids, label, restore) {
      flushPendingDeletes();          // an earlier pending batch commits first
      pendingDeletes = ids;
      if (!o.undoBox) { flushPendingDeletes(); return; }
      o.undoBox.appendChild(el("span", null, label));
      var u = el("button", "cnc-undo__btn", "Undo");
      u.type = "button";
      u.addEventListener("click", function () {
        if (undoTimer) { clearTimeout(undoTimer); undoTimer = null; }
        pendingDeletes = [];
        o.undoBox.hidden = true;
        while (o.undoBox.firstChild) o.undoBox.removeChild(o.undoBox.firstChild);
        restore();
      });
      o.undoBox.appendChild(u);
      o.undoBox.hidden = false;
      undoTimer = setTimeout(flushPendingDeletes, UNDO_MS);
    }
    window.addEventListener("pagehide", flushPendingDeletes);
    function open(id) { flushPendingDeletes(); setHistoryOpen(false); o.setSubhead(""); o.openConversation(id); }
    function fresh() { flushPendingDeletes(); setHistoryOpen(false); o.setSubhead(""); o.startFresh(); }
    function renderHistory() {
      setHistoryOpen(true);
      // Final review, Finding 5 (kept from v1): null the capture model with
      // the DOM wipe, or a stale in-progress model stays readable by Save.
      o.state.capture = null;
      renderTokens(root, null);
      while (o.thread.firstChild) o.thread.removeChild(o.thread.firstChild);
      o.setSubhead(conversations.length ? conversations.length + " saved conversations" : "");
      if (!conversations.length) {
        var empty = el("div", "cnc-history__empty");
        empty.appendChild(el("p", "cnc-history__title", "No saved conversations"));
        empty.appendChild(el("p", "cnc-history__emptytext",
          "Briefs you send are kept here so you can pick one back up."));
        var start = el("button", "cnc-history__start", "Start a brief");
        start.type = "button";
        start.addEventListener("click", fresh);
        empty.appendChild(start);
        o.thread.appendChild(empty);
        return;
      }
      var box = el("div", "cnc-history");
      var top = el("div", "cnc-history__toprow");
      top.appendChild(el("span", "cnc-history__title", "Your conversations"));
      var clearBtn = el("button", "cnc-history__clear", "Delete all");
      clearBtn.type = "button";
      clearBtn.addEventListener("click", function () {
        var snapshot = conversations.slice();
        conversations = [];
        renderHistory();
        queueUndo(snapshot.map(function (c) { return c.id; }), "All conversations deleted", function () {
          conversations = snapshot; renderHistory();
        });
      });
      top.appendChild(clearBtn);
      box.appendChild(top);
      historyGroups(conversations.slice(0, 8), Date.now()).forEach(function (group) {
        box.appendChild(el("span", "cnc-history__head", group.title));
        group.items.forEach(function (c) {
          var row = el("div", "cnc-history__row");
          var b = el("button", "cnc-history__item");
          b.type = "button";
          b.appendChild(el("span", null, c.title || "Untitled conversation"));
          b.appendChild(el("span", "cnc-history__time", relTime(c.updated_at)));
          b.addEventListener("click", function () { open(c.id); });
          var del = el("button", "cnc-history__del", "×");
          del.type = "button";
          del.setAttribute("aria-label", "Delete conversation");
          del.title = "Delete conversation";
          del.addEventListener("click", function () {
            var snapshot = conversations.slice();
            conversations = conversations.filter(function (x) { return x.id !== c.id; });
            row.remove();
            queueUndo([c.id], "Conversation deleted", function () {
              conversations = snapshot; renderHistory();
            });
          });
          row.appendChild(b); row.appendChild(del);
          box.appendChild(row);
        });
      });
      o.thread.appendChild(box);
    }
    if (o.historyBtn) o.historyBtn.addEventListener("click", function () {
      if (o.state.historyOpen) {
        if (o.state.conversationId) open(o.state.conversationId);
        else fresh();
      } else renderHistory();
    });
    if (o.freshBtn) o.freshBtn.addEventListener("click", fresh);
    return {
      setConversations: function (list) { conversations = list || []; },
      count: function () { return conversations.length; },
      renderHistory: renderHistory,
      open: open,
      fresh: fresh,
      flush: flushPendingDeletes,
    };
  }

  // Human handoff (D4 stage 1, CV-5/CV-13): POST the route, drop a system
  // message into the thread, then reveal Shopify Inbox for this shopper only
  // (role-split — the launcher stays hidden site-wide; CSS in the drawer
  // snippet's stylesheet block). Shared verbatim by BOTH surfaces (full-page
  // redesign 2026-09-01). Re-checks the gate defensively even though the
  // button is hidden outside it (syncActions), since a click can be in
  // flight when state changes underneath it (e.g. "Start fresh").
  function bindHandoff(root, state, handoffBtn, thread, signedIn) {
    if (!handoffBtn) return;
    handoffBtn.addEventListener("click", function () {
      if (!signedIn || !state.conversationId || handoffBtn.disabled) return;
      handoffBtn.disabled = true;
      api(root, "/concierge/handoff", { method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ conversation_id: state.conversationId }) })
        .then(function (r) {
          handoffBtn.disabled = false;
          if (r.status !== 200) return;
          state.handoffRequested = true;
          handoffBtn.hidden = true;
          thread.appendChild(el("p", "cnc-msg cnc-msg--system",
            "You're connected with the gallery — the team will follow up here or by email."));
          scrollThreadToBottom(thread);
          // Inbox loads async and may not be present yet — fail quietly to just
          // the system message above (the message already covers the email
          // fallback), per the verified spike: show() is a real method, "open"
          // is an accessor/attribute, not a call.
          try {
            var chat = document.querySelector("shopify-chat");
            if (chat && typeof chat.show === "function") chat.show();
          } catch (e) {}
        })
        .catch(function () { handoffBtn.disabled = false; });
    });
  }

  // ——— Board selection (2026-09-01): ONE selection serves every account ———
  // Trade routes it to the project boardbar; everyone routes it to
  // "Add selection to cart (N)". The map stores product ids only — variants
  // resolve from the card DOM at ADD time, so a size/substrate/frame tap
  // after selecting still ships exactly what the card shows.
  function initBoardSelect(root, grid) {
    var selected = {};
    var listeners = [];
    function count() { return Object.keys(selected).length; }
    function emit() { var n = count(); listeners.forEach(function (f) { f(n); }); }
    function cards() {
      return Object.keys(selected).map(function (pid) {
        return grid && grid.querySelector('.cnc-card[data-product-id="' + pid + '"]');
      }).filter(Boolean);
    }
    function clear() {
      selected = {};
      root.querySelectorAll(".cnc-card--selected").forEach(function (c) { c.classList.remove("cnc-card--selected"); });
      root.querySelectorAll('[data-cnc-select][aria-pressed="true"]').forEach(function (b) {
        b.setAttribute("aria-pressed", "false");
      });
      emit();
    }
    root.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest("[data-cnc-select]") : null;
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest(".cnc-card");
      var pid = card && card.getAttribute("data-product-id");
      if (!pid) return;
      if (selected[pid]) {
        delete selected[pid];
        card.classList.remove("cnc-card--selected");
        btn.setAttribute("aria-pressed", "false");
      } else {
        selected[pid] = true;
        card.classList.add("cnc-card--selected");
        btn.setAttribute("aria-pressed", "true");
      }
      emit();
    });
    return { count: count, cards: cards, clear: clear,
             onChange: function (f) { listeners.push(f); } };
  }

  // G3a contract helper: a card that never resolved a ladder/row-matched
  // variant falls back to the product's first available variant.
  function defaultVariant(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var av = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
        return av && av.id;
      });
  }

  function initTradeRail(root, mode) {
    if (mode !== "trade" || tradeRailDone) return;
    // The selection-header dropdown is the ONLY project surface (user
    // direction 2026-09-01): the under-composer rail and the boardbar
    // below the results are both gone — the header CTA owns add-to-project.
    var headSel = root.querySelector("[data-cnc-selhead-project]");
    if (!headSel) return;
    tradeRailDone = true;
    root.classList.add("cnc--trade");
    var headBtn = root.querySelector("[data-cnc-saveproject]");
    function syncButtons() {
      if (headBtn) headBtn.disabled = !headSel.value;
    }
    headSel.addEventListener("change", syncButtons);

    function loadProjects() {
      fetch("/apps/arteriel/trade/projects.json", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prev = headSel.value;
          while (headSel.firstChild) headSel.removeChild(headSel.firstChild);
          var ph = document.createElement("option");
          ph.value = ""; ph.textContent = "Select project\u2026";
          headSel.appendChild(ph);
          (data.projects || []).forEach(function (p) {
            var o = document.createElement("option"); o.value = p.id; o.textContent = p.name;
            headSel.appendChild(o);
          });
          // A refresh keeps the working project; no project chosen keeps
          // the add button disabled (user rule 2026-09-01).
          if (prev) headSel.value = prev;
          syncButtons();
        })
        .catch(function () { syncButtons(); });
    }
    loadProjects();
  }

  function cardCtx(root) {
    return {
      customer: root.getAttribute("data-signed-in") === "true",
      trade: root.getAttribute("data-trade") === "true",
      loginUrl: root.getAttribute("data-login-url") || "/account/login",
      returnUrl: location.pathname + location.search
    };
  }

  // Contextual chips: facet coverage over everything the concierge has heard.
  // HEARS (below) doubles as the facet detector list — mirrored with FACETS in
  // assets/concierge-helpers.mjs; keep in sync.
  function coveredFacets(text) {
    return text ? HEARS.filter(function (h) { return h[1].test(text); }).map(function (h) { return h[0]; }) : [];
  }

  // --- guided capture (concierge sub-project 3, 2026-08-31) -----------------
  // captureSteps / captureModel / capturePick / captureAdvance / captureDone /
  // captureSeed / briefSummary mirrored in assets/concierge-helpers.mjs; keep in sync.
  var CAPTURE_STEPS = {
    retail: [
      { key: "space", title: "Where will it live?", chips: ["living room", "bedroom", "office", "hallway", "other"] },
      { key: "palette", title: "Palette & mood", chips: ["warm", "cool", "neutral", "calm", "bold", "moody"] },
      { key: "style", title: "Style & movement", chips: ["Abstract", "Impressionist", "Japanese woodblock", "Photography", "Botanical", "Minimalist", "Art Nouveau", "Contemporary"] },
      { key: "scale", title: "Scale & budget", chips: ["small", "medium", "large", "oversize", "under $500", "$500-$1000", "$1000+"] },
    ],
    trade: [
      { key: "space", title: "Project shape", chips: ["1 room", "2-4 rooms", "5+ rooms", "a few works", "dozens of works"] },
      { key: "palette", title: "Palette & mood", chips: ["warm", "cool", "neutral", "calm", "bold", "moody"] },
      { key: "style", title: "Style & movement", chips: ["Abstract", "Impressionist", "Japanese woodblock", "Photography", "Botanical", "Minimalist", "Art Nouveau", "Contemporary"] },
      { key: "scale", title: "Sizes needed", chips: ["small", "medium", "large", "oversize", "mixed sizes"] },
    ],
  };

  // Panel v2 (Claude Design import 2026-09-01): per-step help lines —
  // render-level only; CAPTURE_STEPS' shape is mirrored in helpers.mjs and
  // stays untouched.
  var CAPTURE_HELP = {
    space: "This shapes scale and how many works I suggest.",
    palette: "Or add a room photo and I'll read the palette for you.",
    style: "One is enough — I'll widen the search around it.",
    theme: "Subject, not style — what the work is of.",
    scale: "Sizes are the longest edge of the framed piece.",
  };

  // themeChips mirrored in assets/concierge-helpers.mjs; keep in sync.
  function themeChips(vocab, max) {
    var values = (vocab && Array.isArray(vocab.theme)) ? vocab.theme : [];
    var cap = max || 8;
    var out = [];
    for (var i = 0; i < values.length && out.length < cap; i += 1) {
      var s = String(values[i] == null ? "" : values[i]).trim();
      if (s && out.indexOf(s) < 0) out.push(s);
    }
    return out;
  }

  // captureSteps mirrored in assets/concierge-helpers.mjs; keep in sync — with
  // ONE deliberate divergence: here the chip list DEFAULTS to the live facet
  // vocabulary, so every existing caller (captureModel, briefSummary,
  // modelFromPrefs) picks up the theme step without a signature change, while
  // the .mjs twin stays pure and requires the list to be passed.
  function captureSteps(mode, themeChipList) {
    var base = CAPTURE_STEPS[mode] || CAPTURE_STEPS.retail;
    var chips = themeChipList || themeChips(FACET_VOCAB);
    if (!chips.length) return base;
    return base.slice(0, 3).concat([{ key: "theme", title: "Subject & theme", chips: chips }],
                                   base.slice(3));
  }

  // Task 12, controller correction: steps a saved brief may CARRY, kept
  // separate from captureSteps' ASK list — see the matching, longer comment
  // in assets/concierge-helpers.mjs for why briefSummary/modelFromPrefs must
  // NOT be gated on the live (or here, FACET_VOCAB-derived) chip list. Do not
  // "simplify" this back into a plain captureSteps(mode) call.
  function withTheme(steps) {
    return steps.slice(0, 3).concat([{ key: "theme", title: "Subject & theme", chips: [] }], steps.slice(3));
  }
  var REMEMBERABLE_STEPS = {
    retail: withTheme(CAPTURE_STEPS.retail),
    trade: withTheme(CAPTURE_STEPS.trade),
  };
  // captureStepsToRemember mirrored in assets/concierge-helpers.mjs; keep in sync.
  function captureStepsToRemember(mode) {
    return REMEMBERABLE_STEPS[mode] || REMEMBERABLE_STEPS.retail;
  }

  // Caret helpers for the contenteditable composer (single text node).
  // Setting textContent resets the caret to position 0; these let onSeed
  // recompose the composer and put the caret back (walkthrough finding
  // 2026-08-31: the first keystroke scrambled the shopper's sentence).
  function caretOffsetIn(node) {
    var sel = window.getSelection();
    if (!sel || !sel.rangeCount) return null;
    var r = sel.getRangeAt(0);
    if (!node.contains(r.endContainer)) return null;
    return r.endOffset;
  }
  function placeCaretAt(node, idx) {
    var t = node.firstChild;
    if (!t || t.nodeType !== 3) return;
    var r = document.createRange();
    r.setStart(t, Math.min(idx, t.textContent.length));
    r.collapse(true);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(r);
  }

  function captureModel(mode, themeChipList) {
    return { mode: mode, steps: captureSteps(mode, themeChipList), idx: 0, picked: {} };
  }

  function capturePick(model, value) {
    var key = model.steps[model.idx].key;
    var cur = model.picked[key] || [];
    var at = cur.indexOf(value);
    var next = at === -1 ? cur.concat([value]) : cur.slice(0, at).concat(cur.slice(at + 1));
    var picked = Object.assign({}, model.picked);
    picked[key] = next;
    return Object.assign({}, model, { picked: picked });
  }

  function captureAdvance(model) {
    return Object.assign({}, model, { idx: model.idx + 1 });
  }

  function captureDone(model) {
    return model.idx >= model.steps.length;
  }

  // advanceLabel mirrored in assets/concierge-helpers.mjs; keep in sync.
  // The advance chip reads "Skip" only while the CURRENT step has zero picks
  // (a bare Skip after picking reads as "discard my pick" — shopper-reported
  // confusion). Once the current step has ≥1 pick it reads "Next", or "Show
  // me" on the last step (same meaning, but signals the flow is about to
  // submit rather than move to another step).
  function advanceLabel(model) {
    var key = model.steps[model.idx].key;
    var picked = model.picked[key];
    if (!picked || !picked.length) return "Skip";
    return model.idx === model.steps.length - 1 ? "Show me" : "Next";
  }

  // captureReopen mirrored in assets/concierge-helpers.mjs; keep in sync.
  // D2: "A tap on a chip in a completed step re-opens that step's row for
  // change until the first submit." Rewinds idx to stepIdx; picks (this
  // step's and every other step's) are preserved untouched.
  function captureReopen(model, stepIdx) {
    return Object.assign({}, model, { idx: stepIdx });
  }

  // captureSeed mirrored in assets/concierge-helpers.mjs; keep in sync.
  // Deterministic natural-prose template — see the .mjs twin for the ruling.
  function captureSeed(model) {
    var lead = "";
    var rest = [];
    model.steps.forEach(function (step) {
      var picks = model.picked[step.key];
      if (!picks || !picks.length) return;
      if (step.key === "space") {
        lead = (model.mode === "retail" ? "For my " : "For ") + picks.join(", ");
      } else if (step.key === "palette") {
        rest.push("something " + picks.join(", "));
      } else if (step.key === "style") {
        rest.push(picks.join(" or ") + " style");
      } else if (step.key === "theme") {
        rest.push("around " + picks.join(" and "));
      } else {
        rest.push(picks.join(", "));
      }
    });
    if (!lead && !rest.length) return "";
    if (!lead) return rest.join(", ") + ".";
    return rest.length ? lead + " — " + rest.join(", ") + "." : lead + ".";
  }

  // mergeSeed mirrored in assets/concierge-helpers.mjs; keep in sync.
  function mergeSeed(seed, typed) {
    var s = seed || "";
    var t = typed || "";
    if (!t.trim()) return s;
    if (!s) return t;
    return s + " " + t;
  }

  // turnPrefs mirrored in assets/concierge-helpers.mjs; keep in sync.
  function turnPrefs(capture) {
    if (!capture || !captureDone(capture)) return null;
    var p = prefsFromModel(capture);
    return Object.keys(p).length ? p : null;
  }

  // Iterates captureStepsToRemember(mode) order rather than
  // Object.keys(prefsForMode) — see the matching comment in
  // assets/concierge-helpers.mjs (final review, Finding 3: DDB map key order
  // is not guaranteed insertion order; Task 12: the REMEMBER list, not the
  // vocab-gated ASK list, so a saved theme is never dropped by it).
  function briefSummary(mode, prefsForMode) {
    if (!prefsForMode) return "";
    return captureStepsToRemember(mode)
      .map(function (step) { return prefsForMode[step.key]; })
      .filter(function (v) { return v; })
      .join(" · ");
  }

  // prefsFromModel / modelFromPrefs mirrored in assets/concierge-helpers.mjs; keep in sync.
  function prefsFromModel(model) {
    var out = {};
    model.steps.forEach(function (step) {
      var picks = model.picked[step.key];
      if (picks && picks.length) out[step.key] = picks[0];
    });
    return out;
  }

  function modelFromPrefs(mode, prefsForMode) {
    var steps = captureStepsToRemember(mode);
    var picked = {};
    steps.forEach(function (step) {
      var v = prefsForMode && prefsForMode[step.key];
      if (v) picked[step.key] = [v];
    });
    return { mode: mode, steps: steps, idx: steps.length, picked: picked };
  }

  // BLOCKER fix (final review, Finding 1b): a saved brief with no keys (a
  // Save after skip-all-capture) must be treated as ABSENT wherever a saved
  // brief gates the seed-line/choice-vs-capture decision — otherwise a
  // shopper who ever skip-alls-then-saves gets permanently stuck on the
  // degenerate "Working from your saved brief — ." line every boot, with no
  // path back into capture (renderSaveOffer's own emptiness guard, above,
  // stops a NEW empty brief from ever being saved this way again, but an
  // already-saved empty one must still degrade gracefully here).
  function hasSavedBrief(prefsForMode) {
    return !!prefsForMode && Object.keys(prefsForMode).length > 0;
  }

  // Renders the CURRENT step of an in-progress capture as a chip row inside
  // the thread. `state` is the caller's (initDrawer/initPage) per-surface
  // state object — passed explicitly (rather than closed over) so this one
  // function serves both surfaces (drawer-parity rule). Re-invoked on every
  // pick to re-render the toggled aria-pressed state; removes itself and
  // hands off to `submitText` once the shopper reaches the end.
  function renderCapture(thread, root, state, submitText) {
    var old = thread.querySelector("[data-cnc-capture]");
    if (old) old.remove();
    var model = state.capture;
    if (!model || captureDone(model)) { renderTokens(root, model); return; }
    var step = model.steps[model.idx];
    var box = el("div", "cnc-capture");
    box.setAttribute("data-cnc-capture", "");
    // Mobile redesign (2026-09-01): completed answers live ONLY in the
    // YOUR BRIEF token band — no duplicated pressed-chip rows here (Back and
    // token \u00d7 cover editing; supersedes the D2 reopen rows).
    var stepbar = el("div", "cnc-capture__stepbar");
    stepbar.appendChild(el("span", "cnc-capture__steplabel", "Step " + (model.idx + 1) + " of " + model.steps.length));
    var skipBtn = el("button", "cnc-capture__skip", "Skip this");
    skipBtn.type = "button";
    skipBtn.addEventListener("click", function () { advance(); });
    stepbar.appendChild(skipBtn);
    box.appendChild(stepbar);
    var prog = el("div", "cnc-capture__progress");
    var progFill = el("div", "cnc-capture__progress-fill");
    progFill.style.width = Math.round(((model.idx + 1) / model.steps.length) * 100) + "%";
    prog.appendChild(progFill);
    box.appendChild(prog);
    box.appendChild(el("p", "cnc-capture__question", step.title));
    if (CAPTURE_HELP[step.key]) box.appendChild(el("p", "cnc-capture__help", CAPTURE_HELP[step.key]));
    var sub = root.querySelector("[data-cnc-subhead]");
    if (sub) { sub.textContent = model.steps.length + " quick questions, then I'll show you work"; sub.hidden = false; }
    if (step.key === "scale") {
      // Size-guide hint (user direction 2026-09-01): the scale words are
      // abstract — show the marketplace's own word->dimensions mapping
      // (merchant-edited setting) and link the sizes page. New tab: mid-
      // capture navigation would lose the flow.
      var hintText = root.getAttribute("data-cnc-size-hint") || "";
      var guideUrl = root.getAttribute("data-cnc-size-guide") || "";
      if (hintText || guideUrl) {
        var sizes = el("p", "cnc-capture__sizes");
        if (hintText) sizes.appendChild(el("span", null, hintText));
        if (guideUrl) {
          var guide = el("a", "cnc-capture__sizes-link", "Size guide \u2192");
          guide.href = guideUrl;
          guide.target = "_blank";
          guide.rel = "noopener";
          sizes.appendChild(guide);
        }
        box.appendChild(sizes);
      }
    }
    var row = el("div", "cnc-followups");
    step.chips.forEach(function (value) {
      var picked = (model.picked[step.key] || []).indexOf(value) !== -1;
      var chip = el("button", "cnc-chip", value);
      chip.type = "button";
      chip.setAttribute("aria-pressed", picked ? "true" : "false");
      chip.addEventListener("click", function () {
        state.capture = capturePick(state.capture, value);
        renderCapture(thread, root, state, submitText);
      });
      row.appendChild(chip);
    });
    function advance() {
      state.capture = captureAdvance(state.capture);
      var done = thread.querySelector("[data-cnc-capture]");
      if (done) done.remove();
      if (captureDone(state.capture)) {
        state.captured = true;
        // Clobber fix (walkthrough 2026-08-31): "Show me" must keep whatever
        // is already in the composer (photodrop palette words, typed prose) —
        // merge the seed ahead of it instead of overwriting.
        var input = root.querySelector("[data-cnc-input]");
        var text = mergeSeed(captureSeed(state.capture), input ? input.textContent : "");
        if (text) submitText(text);
        return;
      }
      renderCapture(thread, root, state, submitText);
    }
    // Mobile redesign: Skip is the link beside the step label; the primary
    // always reads Next / Show me (a bordeaux "SKIP" read as discard, live
    // 2026-09-01).
    var label = model.idx === model.steps.length - 1 ? "Show me" : "Next";
    box.appendChild(row);
    var nav = el("div", "cnc-capture__nav");
    var backBtn = el("button", "cnc-capture__back", "Back");
    backBtn.type = "button";
    if (model.idx === 0) backBtn.disabled = true;
    else backBtn.addEventListener("click", function () {
      state.capture = captureReopen(state.capture, model.idx - 1);
      renderCapture(thread, root, state, submitText);
    });
    var nextBtn = el("button", "cnc-capture__next", label);
    nextBtn.type = "button";
    nextBtn.addEventListener("click", function () { advance(); });
    nav.appendChild(backBtn); nav.appendChild(nextBtn);
    box.appendChild(nav);
    thread.appendChild(box);
    renderTokens(root, model, function (key, value) {
      var picked = Object.assign({}, state.capture.picked);
      picked[key] = (picked[key] || []).filter(function (v) { return v !== value; });
      state.capture = Object.assign({}, state.capture, { picked: picked });
      renderCapture(thread, root, state, submitText);
    });
  }

  // Starts a fresh, empty capture flow for `mode`.
  function beginCapture(thread, root, state, submitText, mode) {
    state.capture = captureModel(mode);
    renderCapture(thread, root, state, submitText);
  }

  // Applies a saved brief directly: a quiet system line + the brief's prose
  // pre-filled into the composer (editable, not auto-sent) — retail
  // first-boot path, and the "Use saved brief" choice for both modes.
  // `state.capture` is seeded too (idx already at steps.length / done) so a
  // later "Remember this brief" Save round-trips through prefsFromModel even
  // when the shopper never touched a chip this session.
  function applySavedBrief(thread, root, state, onSeed, mode) {
    var prefsForMode = state.prefs && state.prefs[mode];
    var input = root.querySelector("[data-cnc-input]");
    thread.appendChild(el("p", "cnc-msg cnc-msg--system",
      "Working from your saved brief — " + briefSummary(mode, prefsForMode) + ". Change anything?"));
    state.capture = modelFromPrefs(mode, prefsForMode);
    input.textContent = captureSeed(state.capture);
    state.captured = true;
    if (onSeed) onSeed();
  }

  // Two-chip choice for a saved brief that is never auto-applied (trade,
  // always; retail on Start fresh): "Use saved brief" / "Start blank".
  function renderSavedBriefChoice(thread, root, state, submitText, onSeed, mode) {
    var prefsForMode = state.prefs && state.prefs[mode];
    var box = el("div", "cnc-capture");
    box.setAttribute("data-cnc-capture", "");
    box.appendChild(el("p", "cnc-capture__title", "Use your saved brief — " + briefSummary(mode, prefsForMode) + "?"));
    var row = el("div", "cnc-followups");
    var use = el("button", "cnc-chip cnc-chip--send", "Use saved brief");
    use.type = "button";
    use.addEventListener("click", function () {
      box.remove();
      applySavedBrief(thread, root, state, onSeed, mode);
    });
    var blank = el("button", "cnc-chip", "Start blank");
    blank.type = "button";
    blank.addEventListener("click", function () {
      box.remove();
      beginCapture(thread, root, state, submitText, mode);
    });
    row.appendChild(use); row.appendChild(blank);
    box.appendChild(row);
    thread.appendChild(box);
  }

  // Trigger state machine (D1): called once at boot, after prefs/mode are
  // known (or known-absent — anon, or the platform lagging). Never fires
  // while restoring a conversation (state.conversationId already set by
  // then, synchronously, by the caller's history/?c=/resume path).
  function initCaptureTrigger(thread, root, state, submitText, onSeed, mode) {
    // Final review, Finding 5: a lagging boot call can resolve both a
    // .then and a .catch on the same promise (e.g. a bug inside the .then
    // body itself rejects the chain), double-invoking the trigger. A capture
    // already in progress is the trigger's own completion signal — no-op.
    if (state.conversationId || state.capture || state.capturePending) return;
    state.mode = mode;
    // The theme step's chips come from /search/facets (spec §4): wait for that
    // one memoised fetch so the step COUNT is right on the first render. It
    // resolves null on failure rather than rejecting, so capture always opens.
    state.capturePending = true;
    loadFacetVocab(root).then(function () {
      state.capturePending = false;
      if (state.conversationId || state.capture) return;
      if (!state.signedIn) { beginCapture(thread, root, state, submitText, mode); return; }
      var prefsForMode = state.prefs && state.prefs[mode];
      if (!hasSavedBrief(prefsForMode)) { beginCapture(thread, root, state, submitText, mode); return; }
      if (mode === "trade") { renderSavedBriefChoice(thread, root, state, submitText, onSeed, mode); return; }
      applySavedBrief(thread, root, state, onSeed, mode);
    });
  }

  // Save offer (D3): one quiet line after the first successful reply of a
  // captured conversation that actually produced picks (final review,
  // Finding 4 — "after the first successful present_picks", placed after the
  // picks grid/mini-row, not before it). Reuses the feedback-thumbs revert
  // idiom on a non-200 save.
  //
  // BLOCKER fix (final review, Finding 1a): a skip-all capture leaves
  // state.captured true with nothing picked. Offering (and letting the
  // shopper Save) an EMPTY brief would round-trip through get_prefs as a
  // truthy-but-degenerate {} — see initCaptureTrigger's matching guard for
  // why that's a permanent lock-out, not just a cosmetic no-op. Compute the
  // would-be prefs once, up front, and skip the offer entirely when empty.
  function renderSaveOffer(thread, root, state, hasPicks) {
    if (!hasPicks || !state.signedIn || !state.captured || state.prefsOffered) return;
    var mode = state.mode || "retail";
    var prefs = prefsFromModel(state.capture || captureModel(mode));
    if (!Object.keys(prefs).length) return;
    state.prefsOffered = true;
    var row = el("span", "cnc-feedback cnc-saveoffer");
    row.appendChild(el("span", null, "Remember this brief for next time? "));
    var save = el("button", "cnc-saveoffer__btn", "Save");
    save.type = "button";
    var notNow = el("button", "cnc-saveoffer__btn", "Not now");
    notNow.type = "button";
    save.addEventListener("click", function () {
      save.disabled = true; notNow.disabled = true;
      api(root, "/concierge/prefs", { method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: mode, prefs: prefs }) })
        .then(function (r) {
          if (r.status !== 200) { save.disabled = false; notNow.disabled = false; return; }
          row.remove();
        })
        .catch(function () { save.disabled = false; notNow.disabled = false; });
    });
    notNow.addEventListener("click", function () { row.remove(); });
    row.appendChild(save);
    row.appendChild(notNow);
    thread.appendChild(row);
  }

  function updateChips(root, text) {
    var covered = {};
    coveredFacets(text).forEach(function (f) { covered[f] = true; });
    root.querySelectorAll("[data-cnc-chip][data-facet]").forEach(function (chip) {
      chip.hidden = !!covered[chip.getAttribute("data-facet")];
    });
  }

  function syncAskIdle(root, input) {
    var btn = root.querySelector(".cnc-ask");
    if (btn) btn.classList.toggle("cnc-ask--idle", !(input.textContent || "").trim());
  }

  // X1, the other half: make the spent second submit IMPOSSIBLE rather than
  // silently ignored. The compose handlers already refuse it; refusing
  // invisibly is what made the funnel a dead end. Only anon is capped at one
  // turn — a signed-in shopper has a quota, so locking them would be a
  // regression, and the signedIn check guards that explicitly.
  function syncAnonLock(root, state) {
    if (!root || state.signedIn || !state.asked) return;
    var btn = root.querySelector(".cnc-ask");
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute("aria-disabled", "true");
  }

  // relTime mirrored in assets/concierge-helpers.mjs; keep in sync.
  function relTime(iso, now) {
    if (!iso) return "";
    var t = new Date(iso).getTime();
    if (isNaN(t)) return "";
    var sec = Math.max(0, ((now || Date.now()) - t) / 1000);
    if (sec < 60) return "just now";
    if (sec < 3600) return Math.floor(sec / 60) + "m ago";
    if (sec < 86400) return Math.floor(sec / 3600) + "h ago";
    if (sec < 604800) return Math.floor(sec / 86400) + "d ago";
    var d = new Date(t);
    return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][d.getUTCMonth()] + " " + d.getUTCDate();
  }

  // Shopify chat grammar (CV-8): a stamped meta line under each live bubble.
  // Rehydrated turns (loadConversation, the page's ?c= block) render without
  // timestamps — their wall-clock isn't stored — so this is called only from
  // the live-turn submit handlers below.
  function stampTurn(container, sent) {
    // Panel v2 parity: replies sign off as "Concierge · 11:00 PM" (eyebrow,
    // left); sent stamps stay right-aligned receipts.
    var t = el("p", "cnc-msg__meta" + (sent ? "" : " cnc-msg__meta--reply"),
      (sent ? "Sent · " : "Concierge · ") + new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }));
    container.appendChild(t);
  }

  function initDrawer(root) {
    var trigger = document.querySelector("[data-cnc-open]");
    loadFacetVocab(root);
    var scrim = document.querySelector("[data-cnc-scrim]");
    var thread = root.querySelector("[data-cnc-thread]");
    var input = root.querySelector("[data-cnc-input]");
    var meter = root.querySelector("[data-cnc-meter]");
    var signedIn = root.getAttribute("data-signed-in") === "true";
    var pageUrl = root.getAttribute("data-page-url") || "/pages/concierge";
    var state = { conversationId: null, anonKey: null, asked: false, busy: false, heard: "", handoffRequested: false, historyOpen: false,
                  lastSearch: null,
                  signedIn: signedIn, mode: null, prefs: null, capture: null, captured: false, prefsOffered: false, seedingPhoto: false };
    var ctx = cardCtx(root);
    // "Change this wall" (design-agent PR 4b): on a page that hosts the Wall Space Designer the
    // line can go to the wall's agent instead of the concierge. Ready = the designer answered a
    // ping (or announced itself); on by default while ready; the chip turns it off and on.
    var spaceChip = root.querySelector("[data-cnc-spacemode]");
    state.space = { hasDesigner: !!document.querySelector("[data-space-designer]"), ready: false, pressed: null };
    if (input && !input.getAttribute("data-placeholder-default")) input.setAttribute("data-placeholder-default", input.getAttribute("data-placeholder") || "");
    function syncSpaceMode() {
      var m = spaceModeState(state.space);
      if (spaceChip) { spaceChip.hidden = !m.show; spaceChip.setAttribute("aria-pressed", String(m.on)); }
      if (input) input.setAttribute("data-placeholder", m.on ? SPACE_PLACEHOLDER : (input.getAttribute("data-placeholder-default") || ""));
    }
    if (state.space.hasDesigner) {
      window.addEventListener("message", function (e) { if (sameWindow(e, window) && e.data.type === SPACE_READY && !state.space.ready) { state.space.ready = true; syncSpaceMode(); } });
      pingDesigner(window, 1500).then(function (ok) { if (ok) { state.space.ready = true; syncSpaceMode(); } });
      if (spaceChip) spaceChip.addEventListener("click", function () { state.space.pressed = spaceModeState(state.space).on ? false : true; syncSpaceMode(); if (input) input.focus(); });
    }
    syncSpaceMode();
    // G3a: cards read the captured/saved scale lazily — capture can finish
    // long after boot, and the saved brief arrives async on the boot call.
    ctx.scale = function () {
      return capturedScale(state.capture, state.prefs, state.mode || (ctx.trade ? "trade" : "retail"));
    };
    // PDF card note: "More like this" action seeds a real turn on this surface.
    ctx.moreLike = function (title, artist, n) { submitText(moreLikeSeed(title, artist, n)); };
    var historyBtn = root.querySelector("[data-cnc-history]");
    var freshBtn = root.querySelector("[data-cnc-fresh]");
    var handoffBtn = root.querySelector("[data-cnc-handoff]");
    var fullBtn = root.querySelector("[data-cnc-fullpage]");
    var resumeBtn = document.querySelector("[data-cnc-resume]");
    var fab = document.querySelector("[data-cnc-page]") ? null : document.querySelector("[data-cnc-fab]");
    var subheadEl = root.querySelector("[data-cnc-subhead]");
    function setSubhead(text) { if (subheadEl) { subheadEl.textContent = text || ""; subheadEl.hidden = !text; } }
    function clearThread() { while (thread.firstChild) thread.removeChild(thread.firstChild); }
    // History/undo cluster is the SHARED implementation (full-page redesign
    // 2026-09-01): initHistoryView owns the exclusive-view pill contract,
    // grouped rows, deferred delete + undo — this surface hands it the
    // mounts plus how to rehydrate a conversation / start fresh
    // (loadConversation/startFresh hoist as function declarations).
    var hv = initHistoryView(root, {
      thread: thread, state: state, historyBtn: historyBtn, freshBtn: freshBtn,
      undoBox: root.querySelector("[data-cnc-undo]"), setSubhead: setSubhead,
      openConversation: loadConversation, startFresh: startFresh,
    });

    // Guided capture (D1): typing is the escape hatch — dismiss an in-progress
    // capture/saved-brief-choice row the moment the shopper writes their own
    // words. Gated on the row's presence in the DOM (not on state.capture
    // being non-null) so this never re-fires after the flow has already
    // completed — state.capture is deliberately left populated post-completion
    // for the later "Remember this brief" save (renderSaveOffer). Skipped
    // entirely while state.seedingPhoto is set (final review, Finding 2b) —
    // that's bindPhoto's own programmatic append, not the shopper typing.
    // RULING (final review, Finding 2a): dismissal never discards answered
    // steps — the partial captureSeed is composed INTO the composer
    // (prepended, single space, ahead of whatever's already typed) before the
    // box is torn down; the Hearing reflection then confirms it same as any
    // other prose.
    function onSeed() {
      var capBox = thread.querySelector("[data-cnc-capture]");
      if (capBox && !state.seedingPhoto && (input.textContent || "").trim()) {
        var seed = state.capture ? captureSeed(state.capture) : "";
        if (seed) {
          // Caret fix (walkthrough 2026-08-31): recompose via mergeSeed, then
          // restore the caret shifted by the prepended seed — assigning
          // textContent alone threw the caret to 0 and scrambled fast typing.
          var off = caretOffsetIn(input);
          input.textContent = mergeSeed(seed, input.textContent);
          placeCaretAt(input, off === null ? input.textContent.length
            : Math.min(seed.length + 1 + off, input.textContent.length));
        }
        capBox.remove();
        state.capture = null;
        renderTokens(root, null);
      }
      updateChips(root, state.heard + " " + (input.textContent || ""));
      syncAskIdle(root, input);
    }
    function submitText(text) {
      if (state.busy) return;
      input.textContent = text;
      var form = root.querySelector("[data-cnc-compose]");
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
    }
    function syncResume() {
      if (resumeBtn) resumeBtn.hidden = !(signedIn && state.conversationId);
      // fab is null on the concierge page (C1) — guard both the element and the dot lookup.
      var fabDot = fab && fab.querySelector("[data-cnc-fab-dot]");
      if (fabDot) fabDot.hidden = !(signedIn && state.conversationId);
    }
    function syncActions() {
      if (historyBtn) historyBtn.hidden = !(signedIn && hv.count());
      if (freshBtn) freshBtn.hidden = !(signedIn && state.conversationId);
      // Handoff only makes sense signed-in with an active conversation to attach
      // to (CV-5/CV-13) — same gate as "Start fresh"; hide rather than no-op so
      // there's never a dead button in the footer. Also stays hidden once a
      // handoff has been requested for THIS conversation — otherwise the very
      // next successful turn re-runs this gate (conversationId is unchanged)
      // and would silently unhide the button, inviting a duplicate POST/system
      // message/chat.show() (fix round 1). Cleared in loadConversation/startFresh
      // — switching conversations legitimately re-offers handoff.
      if (handoffBtn) handoffBtn.hidden = !(signedIn && state.conversationId) || state.handoffRequested;
      // Persistent route to the full page (user report 2026-09-01: no way
      // to navigate there from a reopened drawer).
      if (fullBtn) {
        fullBtn.hidden = !(signedIn && state.conversationId);
        if (state.conversationId) fullBtn.href = pageUrl + "?c=" + encodeURIComponent(state.conversationId);
      }
    }
    function loadConversation(id) {
      // Closing the history view (flush + pill reset) is the factory's job —
      // every history entry point routes through hv.open()/hv.fresh().
      setSubhead("");
      api(root, "/concierge/conversation/" + encodeURIComponent(id)).then(function (r) {
        if (r.status !== 200) {
          // Stale id (expired TTL, other device) — forget it, offer history.
          // captured/prefsOffered (fix round 1, Finding 3) reset alongside
          // handoffRequested — the abandoned conversation's capture state
          // must not leak into whatever the shopper does next.
          clearConversation(); state.conversationId = null; state.handoffRequested = false;
          state.captured = false; state.prefsOffered = false;
          syncResume(); syncActions(); hv.renderHistory();
          return;
        }
        while (thread.firstChild) thread.removeChild(thread.firstChild);
        var heard = [];
        var lastPickCards = null;
        // I1: the scrollTop measurement at the bottom of this function must
        // wait for every turn's cards to have landed — otherwise it measures
        // a thread whose .cnc-picks grids are still empty and lands well
        // short of the true bottom. Collected across the whole loop, not
        // just the last turn, since an earlier turn's fetch can outlast a
        // later one's.
        var pickPromises = [];
        (r.body.turns || []).forEach(function (t) {
          heard.push(t.user_message || "");
          thread.appendChild(el("p", "cnc-msg cnc-msg--user", t.user_message));
          noteLastSearch(state, t.last_search);
          if (t.reply) renderGlance(thread, t.reply, t.last_search, t.picks);
          // Every turn keeps its picks in the scrollback (user report
          // 2026-09-01: a reload showed only the LAST response's artworks) —
          // the same rule as the live path and the page thread. Results-first:
          // the shortlist precedes the reply prose, as in the live path.
          var topPicks = renderPicksBlock(thread, t.picks, t.last_search, pageUrl + "?c=" + encodeURIComponent(id) + "&t=" + t.seq, ctx, id);
          if (topPicks.length) {
            // renderPicksBlock just appended the set-row label + "see all"
            // link as thread's last child — captured so it can be removed
            // if nothing survives hydration (I3), matching the other sites.
            var setrow = thread.lastElementChild;
            // The grid is appended NOW so turns keep their scrollback order;
            // the cards land inside it once their product JSON resolves.
            var grid = el("div", "cnc-picks");
            thread.appendChild(grid);
            lastPickCards = hydrateCards(entriesFor(topPicks), ctx)
              .then(function (cards) {
                if (!cards.length) {
                  // I3: nothing survived (offline blip / every handle
                  // 404ing) — remove this turn's scaffolding instead of
                  // leaving a shortlist header over an empty box.
                  if (setrow && setrow.parentNode) setrow.parentNode.removeChild(setrow);
                  if (grid.parentNode) grid.parentNode.removeChild(grid);
                  return cards;
                }
                cards.forEach(function (c) { grid.appendChild(c); });
                // Residual 4: announce what actually rendered, not the raw count.
                retitleShortlist(setrow, (t.picks || []).length, topPicks.length, cards.length);
                return cards;
              })
              .catch(warnRenderFailure);
            pickPromises.push(lastPickCards);
          }
          if (t.reply) {
            var rr = el("p", "cnc-msg cnc-msg--reply");
            applyReplyMarkup(rr, t.reply, t.last_search, t.picks);
            thread.appendChild(rr);
            if (signedIn && id && t.seq != null) renderFeedback(thread, root, id, t.seq, t.feedback, t.feedback_reason);
          }
        });
        var turns = r.body.turns || [];
        var last = turns[turns.length - 1];
        if (last && last.reply) renderQuickPrompts(thread, last.reply, submitText);
        if (lastPickCards) {
          var fuSlot = el("div", "cnc-followups__slot");
          thread.appendChild(fuSlot);
          lastPickCards.then(function (cards) {
            // I3: no chip row over an empty/removed grid.
            if (cards && cards.length) renderFollowups(fuSlot, cards, input, onSeed, submitText);
            else if (fuSlot.parentNode) fuSlot.parentNode.removeChild(fuSlot);
          });
        }
        // Snapshot BEFORE overwriting:        // Snapshot BEFORE overwriting: re-opening the conversation already active
        // in this session (e.g. History -> same conversation after a handoff)
        // must not clear handoffRequested — the client has in-session ground
        // truth for that exact id and must not discard it (fix round 2). Only a
        // genuinely different id resets the flag: the conversation projection
        // doesn't expose handoff_requested (additive contract, not extended in
        // this task), so a conversation the client has no memory of legitimately
        // re-offers "Talk to the gallery" rather than guessing.
        var sameConv = state.conversationId === id;
        state.conversationId = id; state.heard = heard.join(" ");
        // captured/prefsOffered (fix round 1, Finding 3) follow the same
        // sameConv gate as handoffRequested: reopening the SAME conversation
        // (e.g. History -> same conversation) preserves in-session ground
        // truth about whether it was captured/already offered; switching to
        // a genuinely different, rehydrated conversation must not carry a
        // stale "already offered" flag that would silently suppress a
        // legitimate save offer on that conversation's next turn.
        if (!sameConv) { state.handoffRequested = false; state.captured = false; state.prefsOffered = false; }
        storeConversation(id);
        onSeed(); syncResume(); syncActions();
        // I1, reworked (residual 1): scroll to the bottom NOW and again once
        // every turn's cards have landed. Two bounded runs, for two different
        // ways this used to miss: waiting only for the promises means a
        // product fetch that never settles suppresses the scroll entirely,
        // while asserting only now means cards that land later are below the
        // fold. Neither run can scroll a thread that has no layout box (the
        // init path rehydrates while the drawer is still hidden) — open()
        // kicks it a third time for exactly that case.
        scrollThreadToBottom(thread);
        Promise.all(pickPromises).then(function () { scrollThreadToBottom(thread); });
      });
    }
    function startFresh() {
      setSubhead("");
      clearConversation();
      state.conversationId = null; state.heard = ""; state.asked = false; state.handoffRequested = false;
      state.capture = null; state.captured = false; state.prefsOffered = false;
      state.lastSearch = null;
      input.textContent = "";
      clearThread();
      renderTokens(root, null);
      onSeed(); syncResume(); syncActions();
      // A saved brief is never auto-applied on Start fresh either (D1) — same
      // two-chip choice as first boot, for both retail and trade.
      var mode = state.mode || (ctx.trade ? "trade" : "retail");
      var prefsForMode = state.prefs && state.prefs[mode];
      // BLOCKER fix (final review, Finding 1b): an empty saved brief (see
      // hasSavedBrief) is ABSENT here too, not a legitimate choice to offer.
      if (hasSavedBrief(prefsForMode)) renderSavedBriefChoice(thread, root, state, submitText, onSeed, mode);
      else beginCapture(thread, root, state, submitText, mode);
    }
    if (resumeBtn) resumeBtn.addEventListener("click", function () { open(); });
    if (fab) fab.addEventListener("click", open);
    bindHandoff(root, state, handoffBtn, thread, signedIn);

    if (!signedIn) {
      renderMeter(meter, null, false, root, false);
      // Anon: capture always runs client-side only, no boot round-trip and
      // never a save offer (D3) — no need to wait for anything.
      initCaptureTrigger(thread, root, state, submitText, onSeed, "retail");
    } else {
      api(root, "/concierge/conversations").then(function (r) {
        var mode = ctx.trade ? "trade" : "retail";
        if (r.status === 200) {
          if (r.body.quota) renderMeter(meter, r.body.quota, true, root);
          hv.setConversations(r.body.conversations);
          mode = r.body.mode || mode;
          state.prefs = r.body.prefs || null;
          syncActions();
        }
        // Degrade gracefully if the platform lags (T1 not deployed yet, or
        // this call failed outright): fall through to the plain capture path
        // — absent prefs field ⇒ capture path (expand/contract safe).
        initCaptureTrigger(thread, root, state, submitText, onSeed, mode);
      }).catch(function () {
        initCaptureTrigger(thread, root, state, submitText, onSeed, ctx.trade ? "trade" : "retail");
      });
      var sc = storedConversation();
      if (sc) { state.conversationId = sc; loadConversation(sc); }
    }
    bindChips(root, input, onSeed);
    bindPhoto(root, input, state, onSeed);
    input.addEventListener("input", onSeed);
    syncAskIdle(root, input);
    syncResume();
    if (fab) fab.hidden = false;
    trapFocus(root);

    function open() {
      root.hidden = false; scrim.hidden = false;
      // Mobile first-open (user report 2026-09-01): autofocusing the composer
      // summons the software keyboard over the guided capture in the thread —
      // the drawer is 100dvh and dvh tracks the toolbar, not the keyboard, so
      // nothing resizes to reveal it and a first-time shopper never learns the
      // flow exists. Coarse pointers move dialog focus to the panel instead
      // (keyboard stays down; chips are the primary interaction, typing is one
      // tap away); fine pointers keep the type-immediately affordance.
      if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) root.focus();
      else input.focus();
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      if (fab) fab.hidden = true;
      // Residual 1: the drawer's init path rehydrates a stored conversation
      // while root is still hidden, so every scroll assertion that ran before
      // this point measured a display:none subtree (0/0) and could not move
      // anything. This is the first moment the thread has a layout box.
      scrollThreadToBottom(thread);
    }
    function close() {
      root.hidden = true; scrim.hidden = true;
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (fab) fab.hidden = false;
      // Phones hide the header trigger (one concierge button: the floating one), so
      // focus returns to whichever opener is actually on screen.
      var back = trigger && trigger.getClientRects().length ? trigger : fab;
      if (back) back.focus();
    }
    if (trigger) trigger.addEventListener("click", open);
    // Any link ending "#concierge" (home hero buttons) opens the drawer in place.
    // Its path is the full concierge page, so with the drawer off it still lands there.
    document.addEventListener("click", function (e) {
      var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!a || a.hash !== "#concierge") return;
      e.preventDefault();
      open();
    });
    scrim.addEventListener("click", close);
    root.querySelector("[data-cnc-close]").addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    root.querySelector("[data-cnc-compose]").addEventListener("submit", function (e) {
      e.preventDefault();
      var brief = (input.textContent || "").trim();
      if (!brief || state.asked || state.busy) return;
      state.busy = true;
      var hb = thread.querySelector(".cnc-history"); if (hb) hb.remove();
      state.heard = (state.heard ? state.heard + " " : "") + brief;
      var askBtn = root.querySelector(".cnc-ask");
      if (askBtn) askBtn.disabled = true;
      if (askBtn) askBtn.classList.add("cnc-ask--busy");
      function settle() { state.busy = false; if (askBtn) { askBtn.disabled = false; askBtn.classList.remove("cnc-ask--busy"); } }
      thread.appendChild(el("p", "cnc-msg cnc-msg--user", brief));
      stampTurn(thread, true);
      var progress = el("p", "cnc-progress", "…");
      thread.appendChild(progress);
      progress.scrollIntoView({ block: "nearest" });
      // Residual 5: the terminal catch for this turn. The inner
      // .catch(warnRenderFailure) calls below sit on hydrateCards, which is a
      // SEPARATE promise chain (see that helper's own note) — they never made
      // this one safe. Leave the UI honest rather than swallowing: composer
      // usable, progress line gone, and say so.
      function turnFailed(e) {
        settle();
        if (progress.parentNode) progress.remove();
        thread.appendChild(el("p", "cnc-msg", "Something went wrong — please try again."));
        try { console.error("concierge: turn failed", e); } catch (e2) {}
      }
      if (spaceModeState(state.space).on) {
        // The wall's agent, not the concierge: no conversation, no quota meter, no history — the
        // designer toasts the changes (with Undo); the drawer shows the one-line reply.
        askDesigner(window, brief, 20000).then(function (r) {
          settle(); progress.remove(); stampTurn(thread, false);
          var reply = el("p", "cnc-msg cnc-msg--reply", r.reply);
          thread.appendChild(reply);
          // The cards are in the designer's thread, behind this drawer — say so and go there.
          if (r.ok && r.proposal) {
            var showMe = el("button", "cnc-showme", spaceProposalLabel(r.count));
            showMe.type = "button";
            showMe.addEventListener("click", function () { revealDesignerProposal(document, close); });
            thread.appendChild(showMe);
          }
          reply.scrollIntoView({ block: "nearest" });
          if (r.ok && input) input.textContent = "";
          if (r.timeout) { state.space.ready = false; syncSpaceMode(); }
        }).catch(turnFailed);
        return;
      }
      postTurn(root, brief, state.conversationId, turnPrefs(state.capture), pageContext(root)).then(function (r) {
        if (r.status === 429) { settle(); progress.remove(); thread.appendChild(searchCarryLink(brief, state.lastSearch, state.conversationId)); renderMeter(meter, r.body.quota, signedIn, root, state.asked); return; }
        if (r.status === 401) { settle(); progress.remove(); renderMeter(meter, null, false, root, state.asked); return; }
        if (r.status !== 202) { settle(); progress.textContent = "The concierge is unavailable — try search."; return; }
        if (input) input.textContent = "";   // accepted — clear the composer immediately
        state.conversationId = r.body.conversation_id;
        state.anonKey = r.body.anon_key || null;
        state.asked = !signedIn;   // anon: single turn
        var seq = turnSeq(r.body.turn_id);
        if (signedIn) storeConversation(state.conversationId);
        onSeed(); syncResume(); syncActions();
        renderMeter(meter, r.body.quota, signedIn, root, state.asked);
        syncAnonLock(root, state);
        // Returned, not fired and forgotten: an un-returned nested chain
        // rejects into nothing no matter what the outer chain ends with.
        return pollTurn(root, r.body.turn_id, state.anonKey, function (line) { progress.textContent = line || "…"; })
          .then(function (turn) {
            settle();
            progress.remove();
            if (turn.status !== "done") { thread.appendChild(el("p", "cnc-msg", turn.message || "Please try again.")); return; }
            stampTurn(thread, false);
            var reply = el("p", "cnc-msg cnc-msg--reply");
            applyReplyMarkup(reply, turn.reply, turn.last_search, turn.picks);
            // Results-first: glance → shortlist → refiner chips → prose → feedback → prompts.
            renderGlance(thread, turn.reply, turn.last_search, turn.picks);
            noteLastSearch(state, turn.last_search);
            var topPicks = renderPicksBlock(thread, turn.picks, turn.last_search,
              state.conversationId ? pageUrl + "?c=" + encodeURIComponent(state.conversationId) + "&t=" + seq : null, ctx, state.conversationId);
            var grid = null;
            if (topPicks.length) {
              // renderPicksBlock just appended the set-row label + "see all"
              // link as thread's last child — captured so it can be removed
              // if nothing survives hydration (I3), matching the other sites.
              var setrow = thread.lastElementChild;
              // The grid is appended NOW (before the awaited hydrate) so the
              // shortlist keeps its scrollback position; the followups slot
              // is appended AFTER it so the chips land under the cards, not
              // above them, once both resolve (X19).
              grid = el("div", "cnc-picks");
              thread.appendChild(grid);
              var fuSlot = el("div", "cnc-followups__slot");
              thread.appendChild(fuSlot);
              hydrateCards(entriesFor(topPicks), ctx).then(function (cards) {
                if (!cards.length) {
                  // I3: nothing survived — remove this turn's scaffolding
                  // rather than leave a shortlist header and empty box.
                  if (setrow && setrow.parentNode) setrow.parentNode.removeChild(setrow);
                  if (grid.parentNode) grid.parentNode.removeChild(grid);
                  if (fuSlot.parentNode) fuSlot.parentNode.removeChild(fuSlot);
                  return;
                }
                cards.forEach(function (c) { grid.appendChild(c); });
                // Residual 4: announce what actually rendered, not the raw count.
                retitleShortlist(setrow, (turn.picks || []).length, topPicks.length, cards.length);
                if (signedIn && cards.length) renderFollowups(fuSlot, cards, input, onSeed, submitText);
              }).catch(warnRenderFailure);
            }
            thread.appendChild(reply);
            if (signedIn && state.conversationId && !isNaN(seq)) renderFeedback(thread, root, state.conversationId, seq, null);
            if (signedIn) renderQuickPrompts(thread, turn.reply, submitText);
            // Final review, Finding 4: after the shortlist AND the reply — "the line under the
            // reply" (D3) reads as commentary on what was shown, and only when there was one.
            renderSaveOffer(thread, root, state, (turn.picks || []).length > 0);
            (topPicks.length ? grid : reply).scrollIntoView({ block: "nearest" });
            if (state.conversationId) {
              var cta = el("a", "cnc-continue", "Continue on the full page →");
              cta.href = pageUrl + "?c=" + encodeURIComponent(state.conversationId);
              thread.appendChild(cta);
            } else if ((turn.preview || []).length) {
              var blur = el("div", "cnc-picks cnc-picks--blur");
              thread.appendChild(blur);
              hydrateCards(entriesFor(turn.preview, true), ctx).then(function (cards) {
                cards.forEach(function (c) { blur.appendChild(c); });
              }).catch(warnRenderFailure);
            }
            if (input) input.textContent = "";
          });
      }).catch(turnFailed);
    });
  }


  // --- page: palette (C8 — photo never leaves the browser) -----------------
  var COLOR_NAMES = [
    ["warm white", 245, 240, 230], ["cream", 235, 225, 200], ["warm taupe", 180, 160, 140],
    ["walnut", 100, 70, 45], ["charcoal", 55, 55, 55], ["ink", 25, 25, 22],
    ["sage", 150, 165, 140], ["olive", 120, 120, 70], ["cobalt", 50, 80, 160],
    ["slate blue", 100, 115, 140], ["terracotta", 190, 100, 70], ["ochre", 200, 150, 60]
  ];
  function nearestName(r, g, b) {
    var best = COLOR_NAMES[0], bd = Infinity;
    COLOR_NAMES.forEach(function (c) {
      var d = Math.pow(r - c[1], 2) + Math.pow(g - c[2], 2) + Math.pow(b - c[3], 2);
      if (d < bd) { bd = d; best = c; }
    });
    return best[0];
  }
  function extractPalette(file) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var cv = document.createElement("canvas"); cv.width = 32; cv.height = 32;
        var ctx = cv.getContext("2d"); ctx.drawImage(img, 0, 0, 32, 32);
        var data = ctx.getImageData(0, 0, 32, 32).data, buckets = {};
        for (var i = 0; i < data.length; i += 4) {
          var k = [data[i] >> 5, data[i + 1] >> 5, data[i + 2] >> 5].join(",");
          var bk = buckets[k] = buckets[k] || { n: 0, r: 0, g: 0, b: 0 };
          bk.n++; bk.r += data[i]; bk.g += data[i + 1]; bk.b += data[i + 2];
        }
        var top = Object.keys(buckets).map(function (k) { return buckets[k]; })
          .sort(function (a, b) { return b.n - a.n; }).slice(0, 3)
          .map(function (b) { return { r: b.r / b.n | 0, g: b.g / b.n | 0, b: b.b / b.n | 0 }; });
        URL.revokeObjectURL(img.src);
        resolve(top);
      };
      img.src = URL.createObjectURL(file);
    });
  }

  // Photo drop -> 3 swatches shown + palette words appended to the brief (C8).
  // Extracted so the drawer (compact photodrop, this task) and the page share
  // one handler; verbatim body from the former initPage-local listener.
  // Concierge ↔ designer bridge (2026-09-08): the conversation is the tray. Signed-in shoppers go to the
  // entry page with the id (and the "Where will it live?" answer as the kind); anonymous via login.
  var ONWALL_KIND = { "living room": "living", "bedroom": "bedroom", "office": "office", "hallway": "hallway" };
  function seeOnWallLink(picks, ctx) {
    var id = (ctx && ctx.conversationId) || storedConversation();
    if (!id || !picks || !picks.length) return null;
    var space = (ctx && ctx.answers && ctx.answers.space) || [];
    var kind = ONWALL_KIND[(Array.isArray(space) ? space[0] : space) || ""] || null;
    var href = "/pages/wall-designer?from=concierge&concierge=" + encodeURIComponent(id) + (kind ? "&kind=" + encodeURIComponent(kind) : "");
    var a = el("a", "cnc-onwall");
    a.href = ctx && ctx.signedIn ? href : "/account/login?return_url=" + encodeURIComponent(href);
    a.appendChild(el("span", "cnc-onwall__title", "See these on a wall"));
    a.appendChild(el("span", "cnc-onwall__sub", "Framed and hung, sized to your wall"));
    a.addEventListener("click", function () { try { sessionStorage.setItem("fb:space:handoff", JSON.stringify({ source: "concierge", conversationId: id, kind: kind || null })); } catch (e) {} });
    return a;
  }

  function offerDesign(root, file, palette) {
    var host = root.querySelector("[data-cnc-photodrop]"); if (!host) return;
    var link = root.querySelector("[data-cnc-design]");
    if (!link) { link = document.createElement("a"); link.setAttribute("data-cnc-design", ""); link.className = "cnc-photodrop__design"; link.href = "/pages/wall-designer?from=concierge"; link.textContent = "Design this wall →"; host.parentNode.insertBefore(link, host.nextSibling); }
    link.onclick = function (ev) {
      ev.preventDefault();
      var img = new Image();
      img.onload = function () {
        try {
          var k = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
          var cv = document.createElement("canvas"); cv.width = Math.round(img.naturalWidth * k); cv.height = Math.round(img.naturalHeight * k);
          cv.getContext("2d").drawImage(img, 0, 0, cv.width, cv.height);
          sessionStorage.setItem("fb:space:handoff", JSON.stringify({ source: "concierge", palette: palette, photo: { src: cv.toDataURL("image/jpeg", 0.86), w: cv.width, h: cv.height } }));
        } catch (e) { /* quota or decode failure: the designer starts without the photo */ }
        location.assign(link.href);
      };
      img.onerror = function () { location.assign(link.href); };
      img.src = URL.createObjectURL(file);
    };
  }
  function bindPhoto(root, input, state, onSeed) {
    var photo = root.querySelector("[data-cnc-photo]");
    if (photo) photo.addEventListener("change", function () {
      if (!photo.files || !photo.files[0]) return;
      var f = photo.files[0];
      var dropLabel = root.querySelector("[data-cnc-photodrop-label]");
      if (!f.type || f.type.indexOf("image/") !== 0) {
        if (dropLabel) dropLabel.textContent = "That file isn't an image — try a photo of the room.";
        return;
      }
      if (dropLabel) dropLabel.textContent = "Reading the room's palette…";
      extractPalette(f).then(function (top) {
        if (dropLabel) dropLabel.textContent = "Room palette read — it never left your device.";
        // Entry into the Wall Space Designer: the photo (downscaled) + palette words travel
        // through sessionStorage; the designer consumes them on an empty space.
        offerDesign(root, f, top.map(function (c) { return nearestName(c.r, c.g, c.b); }));
        var sw = root.querySelector("[data-cnc-swatches]");
        while (sw.firstChild) sw.removeChild(sw.firstChild);
        var names = top.map(function (c) {
          var dot = el("span"); dot.style.background = "rgb(" + c.r + "," + c.g + "," + c.b + ")";
          sw.appendChild(dot);
          return nearestName(c.r, c.g, c.b);
        });
        // Final review, Finding 2b: photodrop is a PROGRAMMATIC append, not
        // the shopper typing their own words — it must not trip the capture
        // dismiss-on-type gate (onSeed, both surfaces). The transient flag is
        // set only around this one mutation + its onSeed call.
        state.seedingPhoto = true;
        input.textContent = (input.textContent + " room palette: " + names.join(", ") + ";").trim();
        onSeed();
        state.seedingPhoto = false;
      });
    });
  }

  // --- page: "what the concierge hears" reflection (never form fields) ------
  var HEARS = [
    ["space", /living room|bedroom|office|hallway|dining|kitchen|lobby|meeting/i],
    ["palette", /neutral|warm|cool|cobalt|ochre|sage|taupe|charcoal|palette|colou?r/i],
    ["size", /\b(large|small|big|six|6-foot|oversized|statement)\b/i],
    ["budget", /under \$?\d+|budget|\$\d/i],
    ["mood", /moody|calm|quiet|bold|dramatic|serene|playful/i]
  ];
  function renderHears(node, brief) {
    var hits = HEARS.filter(function (h) { return h[1].test(brief); })
      .map(function (h) { return h[0]; });
    node.hidden = hits.length === 0;
    while (node.firstChild) node.removeChild(node.firstChild);
    if (hits.length) node.appendChild(el("span", null, "Hearing: " + hits.join(" \u00b7 ")));
  }

  function initPage(root) {
    var grid = root.querySelector("[data-cnc-grid]");
    var thread = root.querySelector("[data-cnc-thread]");
    var input = root.querySelector("[data-cnc-input]");
    var meter = root.querySelector("[data-cnc-meter]");
    var hears = root.querySelector("[data-cnc-hears]");
    var signedIn = root.getAttribute("data-signed-in") === "true";
    var pageUrl = root.getAttribute("data-page-url") || "/pages/concierge";
    var state = { conversationId: new URLSearchParams(location.search).get("c") || storedConversation(), anonKey: null, asked: false, busy: false, heard: "",
                  handoffRequested: false, historyOpen: false, lastSearch: null,
                  signedIn: signedIn, mode: null, prefs: null, capture: null, captured: false, prefsOffered: false, seedingPhoto: false };
    var ctx = cardCtx(root);
    // G3a: cards read the captured/saved scale lazily — capture can finish
    // long after boot, and the saved brief arrives async on the boot call.
    ctx.scale = function () {
      return capturedScale(state.capture, state.prefs, state.mode || (ctx.trade ? "trade" : "retail"));
    };
    // PDF card note: "More like this" action seeds a real turn on this surface.
    ctx.moreLike = function (title, artist, n) { submitText(moreLikeSeed(title, artist, n)); };
    loadFacetVocab(root).then(function () { syncQuestionCopy(); });
    // ——— Full-page redesign (2026-09-01, PDF): page chrome ———
    var subheadEl = root.querySelector("[data-cnc-subhead]");
    function setSubhead(text) { if (subheadEl) { subheadEl.textContent = text || ""; subheadEl.hidden = !text; } }
    // C7 (UI review): every question count is computed from the step table —
    // five with a theme vocabulary, four without — never written out.
    function questionCount() {
      return captureSteps(state.mode || (ctx.trade ? "trade" : "retail")).length;
    }
    function syncQuestionCopy() {
      var n = String(questionCount());
      root.querySelectorAll("[data-cnc-qcount]").forEach(function (node) { node.textContent = n; });
    }
    var historyBtn = root.querySelector("[data-cnc-history]");
    var freshBtn = root.querySelector("[data-cnc-fresh]");
    var handoffBtn = root.querySelector("[data-cnc-handoff]");
    var tabsEl = root.querySelector("[data-cnc-tabs]");
    var hero = root.querySelector("[data-cnc-hero]");
    var selhead = root.querySelector("[data-cnc-selhead]");
    var titleEl = root.querySelector("[data-cnc-title]");
    var searchAllEl = root.querySelector("[data-cnc-searchall]");
    // The canvas count last handed to updateSelhead — syncSearchAll re-applies
    // the header decision with it when the href changes.
    var selheadTotal = 0;
    // One source of truth for "is there a way out": both syncSearchAll and
    // updateSelhead read it, so neither can be left holding a stale answer.
    function searchAllHref() { return searchUrl(state.lastSearch, state.conversationId); }
    // Spec §6.4: once a search has run in this conversation the way out is
    // permanent — not only beneath a result set — and it is worded as what it
    // is. Search is the public floor and is never gated, so this link is live
    // for anonymous and over-quota shoppers too.
    function syncSearchAll() {
      var href = searchAllHref();
      if (searchAllEl) {
        if (href) { searchAllEl.href = href; searchAllEl.hidden = false; }
        else { searchAllEl.hidden = true; }
      }
      // Order-independent by construction: updateSelhead reads searchAllHref()
      // itself, so whichever of the two runs second cannot undo the other —
      // this call only covers the href having changed since the last one.
      updateSelhead(selheadTotal);
    }
    // Title = the shopper's INITIAL request (user direction 2026-09-01);
    // the serif fallback holds until a brief exists.
    function setPageTitle(text) {
      if (!titleEl) return;
      titleEl.textContent = (text || "").trim() || "Your wall, considered.";
    }
    // Selection/Concierge tab pair (PDF p3): the classes only bite inside the
    // sub-desktop media block — harmless chrome on a wide viewport.
    function setTab(name) {
      root.classList.toggle("cnc-page--tab-selection", name === "selection");
      root.classList.toggle("cnc-page--tab-concierge", name === "concierge");
      root.querySelectorAll("[data-cnc-tab]").forEach(function (b) {
        b.setAttribute("aria-selected", b.getAttribute("data-cnc-tab") === name ? "true" : "false");
      });
    }
    if (tabsEl) tabsEl.addEventListener("click", function (e) {
      var b = e.target.closest ? e.target.closest("[data-cnc-tab]") : null;
      if (b) setTab(b.getAttribute("data-cnc-tab"));
    });
    // First visit opens on the concierge side (PDF p3); an existing
    // conversation lands on the work.
    setTab(state.conversationId ? "selection" : "concierge");
    // Board selection serves every account here (user report 2026-09-01):
    // trade adds the selection to a project, everyone can cart just the
    // selection — one selection, two destinations.
    var board = initBoardSelect(root, grid);
    ctx.canSelect = true;
    function updateSelhead(total) {
      if (!selhead) return;
      selheadTotal = Number(total) || 0;
      var view = selheadView(selheadTotal, !!searchAllHref());
      selhead.hidden = view.hidden;
      // A header retained only to host the exit link shows only the exit link:
      // no "Selection · 0 works", and no control that acts on a selection.
      // `hidden` is a free axis here — nothing else in this file sets it on
      // these nodes; the disabled state of [data-cnc-saveproject] stays with
      // its own manager (the project picker's change handler), so neither can
      // undo the other. The two trade controls only exist inside the section's
      // {%- if is_trade -%} branch, hence the per-node null guard.
      SELHEAD_SELECTION_PARTS.forEach(function (sel) {
        var node = selhead.querySelector(sel);
        if (node) node.hidden = !view.hasSelection;
      });
      var countEl = selhead.querySelector("[data-cnc-count]");
      if (countEl) countEl.textContent = String(selheadTotal);
      var tabCount = root.querySelector("[data-cnc-tab-count]");
      if (tabCount) tabCount.textContent = selheadTotal ? " \u00b7 " + selheadTotal : "";
      var mode = state.mode || (ctx.trade ? "trade" : "retail");
      var pf = state.prefs && state.prefs[mode];
      var sumEl = selhead.querySelector("[data-cnc-selsummary]");
      if (sumEl) sumEl.textContent = pf ? briefSummary(mode, pf)
        : (state.capture ? captureSeed(state.capture).replace(/;/g, " \u00b7").replace(/ \u00b7\s*$/, "") : "");
    }
    function syncActions() {
      if (historyBtn) historyBtn.hidden = !(signedIn && hv.count());
      if (freshBtn) freshBtn.hidden = !(signedIn && state.conversationId);
      if (handoffBtn) handoffBtn.hidden = !(signedIn && state.conversationId) || state.handoffRequested;
    }
    function startFresh() {
      clearConversation();
      state.conversationId = null; state.heard = ""; state.asked = false; state.handoffRequested = false;
      state.capture = null; state.captured = false; state.prefsOffered = false;
      state.lastSearch = null;
      input.textContent = "";
      while (thread.firstChild) thread.removeChild(thread.firstChild);
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      // The canvas is gone, so the collapse state that described it goes too
      // (final review, CRITICAL 2): the remainder cache outlives the DOM, and
      // a selection action must never graft the previous conversation's
      // deferred picks into the fresh grid. Bumping the sequence retires any
      // hydrate still in flight for that canvas along with it.
      picksSeq += 1;
      picksHeadCards = []; picksRest = []; picksRestCards = []; picksRestPending = null;
      picksRestDone = false;
      renderTokens(root, null);
      if (hero) hero.hidden = false;
      updateSelhead(0);
      syncSearchAll();
      state.titleFrom = null; setPageTitle(null);
      syncQuestionCopy();
      setSubhead(questionCount() + " quick questions to start");
      try { history.replaceState(null, "", pageUrl); } catch (e2) {}
      onSeed(); syncActions();
      setTab("concierge");
      // Same two-chip saved-brief choice as the drawer (D1 parity).
      var mode = state.mode || (ctx.trade ? "trade" : "retail");
      var prefsForMode = state.prefs && state.prefs[mode];
      if (hasSavedBrief(prefsForMode)) renderSavedBriefChoice(thread, root, state, submitText, onSeed, mode);
      else beginCapture(thread, root, state, submitText, mode);
    }
    var hv = initHistoryView(root, {
      thread: thread, state: state, historyBtn: historyBtn, freshBtn: freshBtn,
      undoBox: root.querySelector("[data-cnc-undo]"), setSubhead: setSubhead,
      onExclusive: function (on) { if (on) setTab("concierge"); },
      openConversation: loadConversation, startFresh: startFresh,
    });
    bindHandoff(root, state, handoffBtn, thread, signedIn);
    // Example briefs (PDF p2) seed the composer and send as a turn.
    root.querySelectorAll("[data-cnc-example]").forEach(function (b) {
      b.addEventListener("click", function () {
        var seed = b.getAttribute("data-seed") || "";
        if (seed) { setTab("concierge"); submitText(seed); }
      });
    });
    // Add set to cart (PDF p1): every visible card's variant, then the cart.
    var addsetBtn = root.querySelector("[data-cnc-addset]");
    function syncAddset(n) {
      if (addsetBtn) addsetBtn.textContent = n ? "Add selection to cart (" + n + ")" : "Add set to cart";
    }
    board.onChange(syncAddset);
    if (addsetBtn) addsetBtn.addEventListener("click", function () {
      if (addsetBtn.disabled) return;
      // The source is the shopper's WHOLE shortlist (selectionCards), which
      // may have to hydrate the deferred remainder first — so the button
      // disables across that wait and a second click cannot start a second
      // add (final review, CRITICAL 2, 2026-09-14).
      var framedCards = [];
      addsetBtn.disabled = true;
      selectionCards().then(function (source) {
        var items = [];
        // Framed picks quick-add with the DEFAULT moulding (user direction
        // 2026-09-01): server-composed line properties via frame-line-attrs —
        // no client price anywhere. Compose failure refuses the whole add
        // (fail closed) rather than carting an unspecified frame.
        framedCards = source.filter(function (c) { return c.dataset.framed === "true"; });
        source.forEach(function (c) {
          if (c.dataset.framed === "true") return;
          var v = Number(c.dataset.variantId); if (v) items.push({ id: v, quantity: 1 });
        });
        if (!items.length && !framedCards.length) { addsetBtn.disabled = false; return null; }
        return composeFramedItems(framedCards).then(function (framedItems) {
          framedItems.forEach(function (it) {
            items.push({ id: it.id, quantity: 1, properties: it.properties });
          });
          return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }) });
        }).then(function (r) {
          if (r.ok) location.href = localePath("/cart"); else throw new Error("cart_add_failed");
        });
      }).catch(function () {
        addsetBtn.disabled = false;
        if (framedCards.length) flashFrameFail(addsetBtn, framedCards.length);
      });
    });
    // Trade: Add selection to project (user direction 2026-09-01) — one lane:
    // board-selected cards when a selection exists, otherwise the whole
    // shortlist (the addset source rule, selectionCards), posted to the
    // project chosen in the HEADER dropdown. No project chosen = button
    // disabled (loadProjects keeps that in sync).
    var saveProjBtn = root.querySelector("[data-cnc-saveproject]");
    var saveProjSel = root.querySelector("[data-cnc-selhead-project]");
    if (saveProjBtn) saveProjBtn.addEventListener("click", function () {
      var projectId = saveProjSel && saveProjSel.value;
      if (!projectId || saveProjBtn.disabled) return;
      // Same whole-shortlist source as the cart lane (final review, CRITICAL
      // 2): a trade account saving half a client's shortlist into a project,
      // silently, is the worst outcome of the two.
      var framedCards = [];
      saveProjBtn.disabled = true;
      selectionCards().then(function (source) {
        // Framed picks (user direction 2026-09-01): the project line stores the
        // composed cart payload as its spec — the SAME contract the PDP's
        // "Add to project" uses — so the project and the order placed from it
        // carry the full framing. Compose failure refuses (fail closed).
        framedCards = source.filter(function (c) { return c.dataset.framed === "true"; });
        var plainCards = source.filter(function (c) { return c.dataset.framed !== "true"; });
        // Nothing to save is not a success: never report "Added to project"
        // over an empty post set (the cart lane has always refused this way).
        if (!framedCards.length && !plainCards.length) { saveProjBtn.disabled = false; return null; }
        return composeFramedItems(framedCards).then(function (framedItems) {
          var framedPosts = framedItems.map(function (it, i) {
            var handle = framedCards[i].getAttribute("data-handle");
            return fetch("/apps/arteriel/trade/add-to-project", {
              method: "POST", credentials: "same-origin",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                variantId: String(it.id), qty: 1, projectId: projectId,
                spec: {
                  items: [{ id: it.id, quantity: 1, properties: it.properties }],
                  url: pdpConfigUrl(handle, it.id) + "&fb_frame=" + encodeURIComponent(it._fbId),
                },
              }),
            });
          });
          return Promise.all(framedPosts.concat(plainCards.map(function (c) {
            // G3a contract: the card carries its ladder/row-matched variant —
            // read LIVE at add time, so a row tap after selecting still ships
            // what the card shows; only a card that never resolved one falls
            // back to the first available.
            var v0 = c.dataset.variantId || "";
            var vid = v0 ? Promise.resolve(v0) : defaultVariant(c.getAttribute("data-handle"));
            return Promise.resolve(vid).then(function (v) {
              if (!v) throw new Error("no variant");
              return fetch("/apps/arteriel/trade/add-to-project", {
                method: "POST", credentials: "same-origin",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ variantId: v, qty: 1, projectId: projectId }),
              });
            });
          })));
        }).then(function () {
          board.clear();
          saveProjBtn.textContent = "Added to project \u2713";
          saveProjBtn.disabled = !(saveProjSel && saveProjSel.value);
        });
      }).catch(function () {
        saveProjBtn.disabled = false;
        if (framedCards.length) flashFrameFail(saveProjBtn, framedCards.length);
      });
    });
    // G5: a /search carry (?seed=) means the visitor arrived with words —
    // prefill the composer and never open capture over them (same rule as
    // typing-dismissal, it just happened on /search).
    // ?t=<seq> (user report 2026-09-01): a drawer set-row deep-links a
    // SPECIFIC turn — that turn's picks take the canvas instead of the
    // default last-pick-bearing walk-back.
    var focusTurn = parseInt(new URLSearchParams(location.search).get("t") || "", 10);
    var carried = carriedSeed(location.search);
    if (carried && !(input.textContent || "").trim()) input.textContent = carried;
    initMeter(root, meter, signedIn, function (body) {
      state.prefs = (body && body.prefs) || null;
      state.mode = (body && body.mode) || null;
      hv.setConversations(body && body.conversations);
      syncActions();
      var mode = (body && body.mode) || (ctx.trade ? "trade" : "retail");
      initTradeRail(root, mode);
      // Restoring ?c=/resume never triggers capture — state.conversationId is
      // already set synchronously above when present (drawer parity, D1).
      if (!carried) {
        if (!state.conversationId) {
          loadFacetVocab(root).then(function () {
            syncQuestionCopy();
            if (!state.conversationId) setSubhead(questionCount() + " quick questions to start");
          });
        }
        initCaptureTrigger(thread, root, state, submitText, onSeed, mode);
      }
    });

    function submitText(text) {
      if (state.busy) return;
      input.textContent = text;
      var form = root.querySelector("[data-cnc-compose]");
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
    }

    // A newer turn must win the canvas even if an older turn's fetches
    // resolve later — the render is sequenced, not raced.
    var picksSeq = 0;
    // Collapse state lives for the conversation only (spec §5.2) — nothing is
    // persisted, and "Start fresh" rebuilds the canvas from scratch anyway.
    var picksHeadCards = [];   // the collapsed set, already hydrated
    var picksRest = [];        // entries NOT yet hydrated (spec §5.4)
    var picksRestCards = [];   // the remainder's cards, once expanded
    function phoneNarrow() {
      try { return window.matchMedia("(max-width: 749px)").matches; } catch (e) { return false; }
    }
    function renderPicks(picks, preview) {
      // A done turn with no picks (e.g. a question the concierge can only answer
      // in prose) must never wipe the existing shortlist — work stays visible.
      if (!(picks || []).length && !(preview || []).length) { grid.classList.remove("cnc-grid--busy"); return; }
      var mode = state.mode || (ctx.trade ? "trade" : "retail");
      var entries = entriesFor(picks).concat(entriesFor(preview, true));
      var cap = gridCapModel(entries.length, mode, phoneNarrow());
      // Held, NOT published (re-review of the CRITICAL 2 fix, 2026-09-14):
      // picksSeq bumps synchronously but the grid wipe, picksHeadCards and
      // the expander only happen when the head hydration RESOLVES. Assigning
      // picksRest here left a clickable window — and, on the zero-card path
      // below, a permanent state — in which picksRest described THIS turn
      // while the grid still showed the previous one, so a cart or project
      // add mixed two turns' works together. The remainder is published with
      // the canvas it belongs to, inside the .then.
      var rest = entries.slice(cap.shown, cap.total);
      // `entries` shifts meaning here: everything above is this turn's full
      // list; from here down it's just the collapsed head — kept as the
      // same name (not renamed to e.g. `head`) so the hydrate-call text
      // below stays "hydrateCards(entries, ctx)", which
      // tests/concierge-hydration-order.test.mjs asserts on literally.
      entries = entries.slice(0, cap.shown);   // only the collapsed set hydrates now
      var mySeq = ++picksSeq;
      // Only the collapsed set hydrates now — hiding DOM does not defer a
      // fetch, so 24 cards on a phone would be 24 parallel product calls
      // whether the shopper expanded or not (spec §5.4).
      return hydrateCards(entries, ctx).then(function (cards) {
        if (mySeq !== picksSeq) return;
        // I2 (review round 2): the busy dimming must survive until THIS
        // turn's own result is known — clearing it in the submit handler's
        // settle() ran in the same tick as the OLD turn's cards were still
        // showing, so the previous turn's shortlist un-dimmed at full
        // opacity before the new one had even started fetching.
        grid.classList.remove("cnc-grid--busy");
        // I3: a transient network blip that fails every handle must not wipe
        // the existing shortlist either — same "work stays visible" contract
        // as the empty-INPUT guard above, now covering an empty RESULT too.
        if (!cards.length) return;
        while (grid.firstChild) grid.removeChild(grid.firstChild);
        picksHeadCards = cards;
        // The canvas and the remainder that describes it are published in one
        // step: every reader of picksRest (both selection actions and the
        // expander) is then talking about the cards now in the grid, and a
        // previous turn's in-flight remainder is retired with it.
        picksRest = rest;
        picksRestCards = [];
        picksRestPending = null;
        picksRestDone = false;
        cards.forEach(function (c) { grid.appendChild(c); });
        if (picksRest.length) grid.appendChild(expandControl(mySeq, cap.total));
        // Bridge (2026-09-08): one action under the grid — "See these on a wall" (replaces any earlier one).
        var oldOnwall = grid.parentNode && grid.parentNode.querySelector(".cnc-onwall");
        if (oldOnwall) oldOnwall.remove();
        var onwall = seeOnWallLink(picks, { conversationId: state.conversationId, signedIn: !!state.signedIn, answers: (state.capture && state.capture.picked) || state.prefs || {} });
        if (onwall && grid.parentNode) grid.parentNode.insertBefore(onwall, grid.nextSibling);
        // Work arrived: the hero yields, the selection header takes over, and
        // sub-desktop lands on the Selection tab ("Show me the works", PDF p3).
        if (hero) hero.hidden = true;
        // Optimistic upper bound BY DESIGN: picksRest hasn't hydrated yet,
        // so some of it may still 404 (live precedent: X19 saw this on 2 of
        // 6 picks) — the true count is unknowable without fetching it, and
        // fetching it up front is exactly the waste deferred hydration
        // removed. Do not "fix" this by hydrating everything here; it self-
        // corrects the moment the shopper expands (see expandControl below).
        updateSelhead(cards.length + picksRest.length);
        setSubhead("Working on your wall");
        setTab("selection");
      }).catch(warnRenderFailure);
    }

    // ——— The remainder, on demand (final review, CRITICAL 2, 2026-09-14) ———
    // Deferred hydration left the remainder OUT of the DOM until the shopper
    // expands. Two readers Task 10 never touched were built on "the whole
    // shortlist is in the grid" — "Add set to cart" and "Add selection to
    // project" both fall back to the grid's cards when no board selection
    // exists — so they delivered only the collapsed head while the header
    // directly above them announced the full count, and they delivered a
    // DIFFERENT set after an expand/collapse cycle, when the remainder is
    // merely `hidden`. ONE hydrate-the-remainder path now serves the
    // expander and both actions, so the DOM, the cache and the announced
    // count can never disagree, and an action firing mid-expand can neither
    // double-fetch nor double-insert.
    var picksRestPending = null;
    // Hydrated-for-this-canvas, which is NOT "picksRestCards.length" — an
    // all-404 remainder resolves to zero cards, and inFlight evicts on
    // settle, so keying the short-circuit on the card count re-issued the
    // whole failed batch on every click (MINOR, re-review 2026-09-14).
    var picksRestDone = false;
    function ensurePicksRest(mySeq) {
      if (picksRestDone || !picksRest.length) return Promise.resolve(picksRestCards);
      if (picksRestPending) return picksRestPending;
      // The canvas this batch belongs to. picksSeq alone cannot tell two
      // canvases apart: it advances when a turn STARTS, while picksRest is
      // published when that turn's head LANDS, so a remainder fetched for
      // the canvas on screen can resolve after the next turn has replaced it
      // under the same sequence number.
      var batch = picksRest;
      var p = hydrateCards(picksRest, ctx, picksHeadCards.length).then(function (more) {
        if (picksRestPending === p) picksRestPending = null;
        if (mySeq !== picksSeq || picksRest !== batch) return [];
        picksRestDone = true;
        picksRestCards = more;
        var btn = grid.querySelector("[data-cnc-expand]");
        // LOW (re-review 2026-09-16): on the I3 zero-card path picksSeq
        // advances while the canvas, picksRest and this button all stay on
        // the previous turn, so expandControl's own seq guard makes the
        // button inert. Writing a freshly-computed "Show all N" onto it
        // presents a live control that does nothing when clicked. Retire it
        // instead — the same disposal the all-404 branch below uses, and for
        // the same reason: never offer a count the control cannot deliver.
        if (btn && btn.getAttribute("data-cnc-expand") !== String(picksSeq)) {
          if (btn.parentNode) btn.parentNode.removeChild(btn);
          btn = null;
        }
        var collapsed = !btn || btn.getAttribute("aria-expanded") !== "true";
        more.forEach(function (c) {
          // Hydrating for a cart add must not expand the canvas under the
          // shopper: the cards go in where the expander would have put them,
          // hidden, and the expander only unhides them.
          c.hidden = collapsed;
          if (btn) grid.insertBefore(c, btn); else grid.appendChild(c);
        });
        // Some of picksRest may have 404'd (live precedent: X19 saw this on
        // 2 of 6), so the true total is only knowable now — every consumer
        // of a count (the header, and every "Show all N" the button renders
        // from here on) must announce what the canvas can actually deliver.
        var n = picksHeadCards.length + more.length;
        updateSelhead(n);
        if (!more.length) {
          // Every deferred handle failed: there is nothing behind the
          // expander, so retire it rather than leave it offering a count the
          // canvas already shows. picksRestDone keeps later clicks from
          // re-issuing the same batch (MINOR, re-review 2026-09-14).
          if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
        } else if (btn && collapsed) {
          btn.textContent = "Show all " + n;
        }
        return more;
      }).catch(function (e) {
        if (picksRestPending === p) picksRestPending = null;
        warnRenderFailure(e);
        return [];
      });
      picksRestPending = p;
      return p;
    }

    function gridPickCards() {
      return [].slice.call(grid.querySelectorAll(".cnc-card:not(.cnc-card--blur)"));
    }

    // The source both selection actions act on: the board selection when one
    // exists, otherwise the shopper's WHOLE shortlist — which means
    // hydrating the deferred remainder first when it has not been fetched
    // yet. Suppressing the actions while collapsed was rejected: the shopper
    // asked for their selection and the header already told them how many
    // they have. X19 still holds through this path — an entry whose handle
    // 404s produces no card at all, so it can never become a phantom cart
    // line, and ensurePicksRest corrects the announced count to what
    // actually hydrated, so the button delivers exactly what it says.
    function selectionCards() {
      if (board.count()) return Promise.resolve(board.cards());
      // MINOR RESIDUAL (re-review 2026-09-16): if the canvas is replaced while
      // this remainder is in flight, ensurePicksRest's identity guard DROPS it
      // — which is exactly what keeps two turns' works out of one cart. But
      // the grid then holds a different turn whose own remainder was never
      // fetched, so returning here handed the cart that turn's seated head
      // while the header announced its full count: coherent, all on-screen,
      // and still less than promised. Re-run ONCE against the canvas now on
      // screen. Once, not a loop — a canvas that keeps changing settles on
      // what is actually displayed rather than chasing each new turn.
      var seq = picksSeq, batch = picksRest;
      return ensurePicksRest(seq).then(function () {
        if (seq === picksSeq && picksRest === batch) return null;
        return ensurePicksRest(picksSeq);
      }).then(gridPickCards);
    }

    // Two-way collapse (spec §5.2): "Show all N" <-> "Show fewer". The control
    // keeps its own row open or closed, so collapsing returns the canvas to
    // exactly the height it had and the page does not jump.
    function expandControl(mySeq, total) {
      var btn = el("button", "cnc-grid__more", "Show all " + total);
      btn.type = "button";
      // The canvas this control belongs to. Its click handler already
      // refuses to act when picksSeq has moved on; carrying the seq in the
      // DOM lets ensurePicksRest see that inertness too, instead of finding
      // the button by attribute alone and relabelling a dead control.
      btn.setAttribute("data-cnc-expand", String(mySeq));
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", function () {
        if (mySeq !== picksSeq) return;
        if (btn.getAttribute("aria-expanded") === "true") {
          picksRestCards.forEach(function (c) { c.hidden = true; });
          btn.setAttribute("aria-expanded", "false");
          btn.textContent = "Show all " + total;
          return;
        }
        btn.setAttribute("aria-expanded", "true");
        btn.textContent = "Show fewer";
        if (picksRestCards.length) {
          picksRestCards.forEach(function (c) { c.hidden = false; });
          // A selection action may have hydrated the remainder, in which case
          // the correction below never ran and `total` is still the
          // pre-hydration guess this button opened with — the next collapse
          // would re-render it (MINOR, re-review 2026-09-14).
          total = picksHeadCards.length + picksRestCards.length;
          return;
        }
        btn.disabled = true;
        // May already be in flight (or already done) from a selection
        // action — ensurePicksRest hands back the same cards either way,
        // and never fetches or inserts twice.
        ensurePicksRest(mySeq).then(function (more) {
          btn.disabled = false;
          if (mySeq !== picksSeq) return;
          more.forEach(function (c) { c.hidden = false; });
          // The pre-hydration `total` this button opened with was an upper
          // bound; correct it so every later collapse announces a count the
          // canvas can deliver.
          total = picksHeadCards.length + more.length;
        }).catch(warnRenderFailure);
      });
      return btn;
    }

    function renderMiniRow(picks, withFollowups) {
      var top = (picks || []).slice(0, INLINE_STRIP_COUNT);
      if (!top.length) return;
      // Every turn keeps its picks inline in the thread scrollback (drawer
      // parity); the grid still shows the latest shortlist as the main canvas.
      var fuSlot = null;
      if (withFollowups && signedIn) { fuSlot = el("div", "cnc-followups__slot"); thread.appendChild(fuSlot); }
      var mini = el("div", "cnc-minirow");
      thread.appendChild(mini);
      hydrateCards(entriesFor(top), ctx).then(function (miniCards) {
        if (!miniCards.length) {
          // I3: nothing survived — no "See all" over an empty row and no
          // chip row under nothing; remove this turn's scaffolding.
          if (mini.parentNode) mini.parentNode.removeChild(mini);
          if (fuSlot && fuSlot.parentNode) fuSlot.parentNode.removeChild(fuSlot);
          return;
        }
        miniCards.forEach(function (c) { mini.appendChild(c); });
        var all = el("a", "cnc-minirow__all", "See all \u2193");
        all.href = "#";
        all.addEventListener("click", function (ev) {
          ev.preventDefault();
          // This TURN's full shortlist takes the canvas (user report
          // 2026-09-01: previous turns' matches were unreachable).
          renderPicks(picks, null);
          grid.scrollIntoView({ behavior: "smooth" });
        });
        mini.appendChild(all);
        if (fuSlot) renderFollowups(fuSlot, miniCards, input, onSeed, submitText);
      }).catch(warnRenderFailure);
    }

    // Rehydrate ?c=<conversation_id> (C3 — the same URL is the resume link).
    // Hoisted as loadConversation so the shared history view opens any saved
    // conversation onto this same path (drawer parity, full-page redesign).
    function loadConversation(id) {
      state.conversationId = id;
      api(root, "/concierge/conversation/" + encodeURIComponent(id))
        .then(function (r) {
          if (r.status !== 200) { clearConversation(); state.conversationId = null; syncActions(); return; }
          while (thread.firstChild) thread.removeChild(thread.firstChild);
          var heard = [];
          var turns = r.body.turns || [];
          state.titleFrom = (turns[0] || {}).user_message || null;
          setPageTitle((turns[0] || {}).user_message);
          turns.forEach(function (turn, idx) {
            heard.push(turn.user_message || "");
            // Every turn, not just the last: a prose-only closing turn carries
            // no last_search, and the way out must survive it (spec §6.4).
            noteLastSearch(state, turn.last_search);
            thread.appendChild(el("p", "cnc-msg cnc-msg--user", turn.user_message));
            var rr = el("p", "cnc-msg cnc-msg--reply");
            applyReplyMarkup(rr, turn.reply, turn.last_search, turn.picks);
            renderGlance(thread, turn.reply, turn.last_search, turn.picks);
            thread.appendChild(rr);
            if (turn.seq != null) renderFeedback(thread, root, id, turn.seq, turn.feedback, turn.feedback_reason);
            if (idx === turns.length - 1) renderQuickPrompts(thread, turn.reply, submitText);
            renderMiniRow(turn.picks, idx === turns.length - 1);
          });
          var last = turns[turns.length - 1];
          // Rehydrate walk-back (live bug fix): the CANVAS restores from the
          // most recent PICK-BEARING turn, not strictly the last turn — a
          // prose-only closing turn must not blank the shortlist. (The
          // drawer keeps every turn inline since 2026-09-01.) renderSeeAll
          // stays keyed to the actual last turn.
          var pickTurn = null;
          if (!isNaN(focusTurn)) pickTurn = turns.filter(function (x) { return x.seq === focusTurn && (x.picks || []).length; })[0] || null;
          if (!pickTurn) pickTurn = lastPicksTurn(turns);
          if (pickTurn) renderPicks(pickTurn.picks, null);
          if (last) renderSeeAll(thread, last.last_search, null, state.conversationId);
          syncSearchAll();
          state.heard = heard.join(" ");
          storeConversation(id);
          try { history.replaceState(null, "", "?c=" + encodeURIComponent(id)); } catch (e2) {}
          onSeed(); syncActions();
        });
    }
    if (state.conversationId && signedIn) loadConversation(state.conversationId);

    // Chips seed prose (sketch 002): shared binding with the drawer.
    // Guided capture (D1): typing is the escape hatch — see the matching
    // comment in initDrawer's onSeed for why this is gated on the row's DOM
    // presence rather than state.capture being non-null, why it's skipped
    // while state.seedingPhoto is set, and why dismissal composes the
    // partial captureSeed into the composer instead of discarding it.
    function onSeed() {
      var capBox = thread.querySelector("[data-cnc-capture]");
      if (capBox && !state.seedingPhoto && (input.textContent || "").trim()) {
        var seed = state.capture ? captureSeed(state.capture) : "";
        if (seed) {
          // Caret fix (walkthrough 2026-08-31): recompose via mergeSeed, then
          // restore the caret shifted by the prepended seed — assigning
          // textContent alone threw the caret to 0 and scrambled fast typing.
          var off = caretOffsetIn(input);
          input.textContent = mergeSeed(seed, input.textContent);
          placeCaretAt(input, off === null ? input.textContent.length
            : Math.min(seed.length + 1 + off, input.textContent.length));
        }
        capBox.remove();
        state.capture = null;
        renderTokens(root, null);
      }
      renderHears(hears, input.textContent || "");
      updateChips(root, state.heard + " " + (input.textContent || ""));
      syncAskIdle(root, input);
    }
    bindChips(root, input, onSeed);
    input.addEventListener("input", onSeed);
    syncAskIdle(root, input);

    // Photo drop -> 3 swatches shown + palette words appended to the brief (C8).
    bindPhoto(root, input, state, onSeed);

    root.querySelector("[data-cnc-compose]").addEventListener("submit", function (e) {
      e.preventDefault();
      var brief = (input.textContent || "").trim();
      if (!brief || (!signedIn && state.asked) || state.busy) return;
      state.busy = true;
      state.heard = (state.heard ? state.heard + " " : "") + brief;
      var askBtn = root.querySelector(".cnc-ask");
      if (askBtn) askBtn.disabled = true;
      if (askBtn) askBtn.classList.add("cnc-ask--busy");
      // I2: cnc-grid--busy is NOT cleared here — it must survive until the
      // new turn's own picks are known (renderPicks clears it, including on
      // an empty result), or the OLD turn's shortlist un-dims at full
      // opacity in the window before the new turn's product fetches land.
      function settle() { state.busy = false; if (askBtn) { askBtn.disabled = false; askBtn.classList.remove("cnc-ask--busy"); } }
      thread.appendChild(el("p", "cnc-msg cnc-msg--user", brief));
      stampTurn(thread, true);
      var progress = el("p", "cnc-progress", "\u2026");
      thread.appendChild(progress);
      progress.scrollIntoView({ block: "nearest" });
      // Residual 5: the terminal catch for this turn. cnc-grid--busy is
      // deliberately NOT cleared by settle() (I2), so a turn that throws before
      // renderPicks would leave the shortlist dimmed forever \u2014 this path is the
      // only other place that can un-dim it. Leave the UI honest rather than
      // swallowing: composer usable, progress line gone, canvas un-dimmed.
      function turnFailed(e) {
        settle();
        grid.classList.remove("cnc-grid--busy");
        if (progress.parentNode) progress.remove();
        thread.appendChild(el("p", "cnc-msg", "Something went wrong \u2014 please try again."));
        try { console.error("concierge: turn failed", e); } catch (e2) {}
      }
      if (!state.titleFrom) { state.titleFrom = brief; setPageTitle(brief); }
      grid.classList.add("cnc-grid--busy");
      postTurn(root, brief, state.conversationId, turnPrefs(state.capture), pageContext(root)).then(function (r) {
        if (r.status === 429) {
          // No renderPicks call follows on this path — clear the dimming here.
          settle(); grid.classList.remove("cnc-grid--busy"); progress.remove();
          thread.appendChild(searchCarryLink(brief, state.lastSearch, state.conversationId));
          renderMeter(meter, r.body.quota, signedIn, root, state.asked);
          syncAnonLock(root, state);
          return;
        }
        if (r.status !== 202) {
          settle(); grid.classList.remove("cnc-grid--busy");
          progress.textContent = r.status === 401 ? "Sign in to continue." : "The concierge is unavailable \u2014 try search.";
          return;
        }
        if (input) input.textContent = "";   // accepted — clear the composer immediately
        state.conversationId = r.body.conversation_id;
        state.anonKey = r.body.anon_key || null;
        state.asked = !signedIn;
        var seq = turnSeq(r.body.turn_id);
        if (state.conversationId) history.replaceState(null, "", "?c=" + encodeURIComponent(state.conversationId));
        if (signedIn) storeConversation(state.conversationId);
        onSeed(); syncActions();
        renderMeter(meter, r.body.quota, signedIn, root, state.asked);
        syncAnonLock(root, state);
        // Returned, not fired and forgotten: an un-returned nested chain
        // rejects into nothing no matter what the outer chain ends with.
        return pollTurn(root, r.body.turn_id, state.anonKey, function (line) { progress.textContent = line || "\u2026"; })
          .then(function (turn) {
            settle(); progress.remove();
            if (turn.status !== "done") {
              // No renderPicks call follows on this path either.
              grid.classList.remove("cnc-grid--busy");
              thread.appendChild(el("p", "cnc-msg", turn.message || "Please try again."));
              return;
            }
            stampTurn(thread, false);
            var reply = el("p", "cnc-msg cnc-msg--reply");
            applyReplyMarkup(reply, turn.reply, turn.last_search, turn.picks);
            renderGlance(thread, turn.reply, turn.last_search, turn.picks);
            thread.appendChild(reply);
            if (signedIn && state.conversationId && !isNaN(seq)) renderFeedback(thread, root, state.conversationId, seq, null);
            renderQuickPrompts(thread, turn.reply, submitText);
            renderPicks(turn.picks, turn.preview);
            renderMiniRow(turn.picks, true);
            // Final review, Finding 4: after the picks mini-row, not before it.
            renderSaveOffer(thread, root, state, (turn.picks || []).length > 0);
            noteLastSearch(state, turn.last_search);
            renderSeeAll(thread, turn.last_search, null, state.conversationId);
            syncSearchAll();
            if (turn.quota) renderMeter(meter, turn.quota, signedIn, root, state.asked);
            reply.scrollIntoView({ block: "nearest" });
          });
      }).catch(turnFailed);
    });
  }

  window.ArterielConcierge = {
    initDrawer: initDrawer,
    initPage: initPage,
    _internals: { el: el, api: api, buildCard: buildCard, hydrateCards: hydrateCards, renderMeter: renderMeter,
                  bindChips: bindChips, renderFollowups: renderFollowups, renderQuickPrompts: renderQuickPrompts,
                  pollTurn: pollTurn, postTurn: postTurn, searchCarryLink: searchCarryLink }
  };

  document.addEventListener("DOMContentLoaded", function () {
    var drawer = document.querySelector("[data-cnc-drawer]");
    var trig = document.querySelector("[data-cnc-open]");
    if (trig && !drawer) trig.hidden = true;
    if (drawer) initDrawer(drawer);
    var page = document.querySelector("[data-cnc-page]");
    if (page && window.ArterielConcierge.initPage) window.ArterielConcierge.initPage(page);
  });
})();
